function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffshoreDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2018_\\u043B\\u043E\\u0439_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3200 2000",
    style: {
      enableBackground: "new 0 0 3200 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FDFFFF"
    },
    width: 3200,
    height: 2000
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.833,
    y: 151.936,
    style: {
      fill: "#D2E4FF"
    },
    width: 3109.792,
    height: 1568.806
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.833,
    y: 1463.684,
    style: {
      fill: "#95B3EF"
    },
    width: 3109.792,
    height: 257.059
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 370.736,
    y: 1017.525,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.029,
    y: 1020.134,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.083,
    height: 147.794
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.209,
    y: 1017.525,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.502,
    y: 1020.134,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1027.139,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 804.925,
    y: 1027.139,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1031.048,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.308,
    y: 1031.048,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.743
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1039.646,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 804.925,
    y: 1039.646,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1043.556,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.308,
    y: 1043.556,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1053.268,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.441,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 804.925,
    y: 1053.268,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.898,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1057.176,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.453,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.308,
    y: 1057.176,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.453,
    height: 1.743
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1068.73,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.441,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 804.925,
    y: 1068.73,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.898,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.279,
    y: 1072.64,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.453,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.308,
    y: 1072.64,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.453,
    height: 1.743
  })), /*#__PURE__*/React.createElement("rect", {
    x: 370.736,
    y: 1181.646,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.029,
    y: 1184.254,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.083,
    height: 147.794
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.209,
    y: 1181.646,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.502,
    y: 1184.254,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.21,
    y: 1273.438,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.705,
    height: 45.764
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.155,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.1,
    y: 1275.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.705,
    height: 43.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.045,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 53.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.989,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.705,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.935,
    y: 1291.791,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 27.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 498.235,
    y: 1273.438,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 45.764
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.18,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.705,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.125,
    y: 1275.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 43.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.07,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 53.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.015,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.959,
    y: 1291.791,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 27.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.835,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.725,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.738,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.835,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.725,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.738,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.71,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.766,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.71,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.766,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.835,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.725,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.738,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.71,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.766,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.835,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.725,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.738,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.974,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.71,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.766,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.74,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.629,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.643,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.74,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.629,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.643,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.615,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.671,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.615,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.671,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.74,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.629,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.643,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.615,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.671,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.74,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.629,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.643,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 465.879,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.615,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.671,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.855,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.744,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.758,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.855,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.744,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.758,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.73,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.786,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.73,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.786,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.855,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.744,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.758,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.73,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.786,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.855,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.744,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.758,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.73,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.786,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1027.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1027.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1027.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1034.65,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1034.65,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1034.65,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1041.609,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1041.609,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1041.609,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1048.134,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1048.134,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1048.134,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1060.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1060.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1060.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1068.191,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1068.191,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1068.191,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1075.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1075.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1075.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1081.675,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1081.675,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1081.675,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1093.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1093.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1093.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1100.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1100.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1100.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1107.823,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1107.823,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1107.823,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.907,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 737.789,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.147,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.925,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.664,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 724.423,
    y: 1114.348,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.431,
    y: 1114.348,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.446,
    y: 1114.348,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1209.426,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1209.426,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1209.426,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1216.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1216.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1216.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1223.784,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1223.784,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1223.784,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1230.309,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1230.309,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1230.309,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1261.781,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1261.781,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1261.781,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1269.181,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1269.181,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1269.181,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1276.14,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1276.14,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1276.14,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.449,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.585,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.323,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.083,
    y: 1282.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822.091,
    y: 1282.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 834.106,
    y: 1282.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.694,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M775.069,1235.298H647.266c0,0,20.537-14.771,26.869-13.998 c6.332,0.773,16.132,6.752,21.913,6.984c5.781,0.231,8.977-20.731,15.517-19.744c6.539,0.988,11.626,19.53,14.677,17.719 c3.052-1.812,12.885-2.597,18.988,0c6.104,2.597,12.885-8.254,17.971-7.915C768.287,1218.683,775.069,1235.298,775.069,1235.298z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 649.301,
    y: 1204.046,
    style: {
      fill: "#F99746"
    },
    width: 24.41,
    height: 1.573
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.301,
    y: 1207.404,
    style: {
      fill: "#F99746"
    },
    width: 24.41,
    height: 1.573
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M394.397,1080.747h182.185c0,0-29.275-21.057-38.302-19.953 c-9.026,1.103-22.996,9.625-31.237,9.956c-8.241,0.33-12.797-29.554-22.12-28.146c-9.322,1.407-16.573,27.84-20.923,25.258 c-4.351-2.582-18.368-3.702-27.068,0c-8.7,3.701-18.368-11.767-25.618-11.283 C404.064,1057.063,394.397,1080.747,394.397,1080.747z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 397.296,
    y: 1040.313,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.296,
    y: 1045.102,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.243
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M594.1,1094.03H385.305v-66.795H594.1V1094.03z M386.487,1092.849h206.431v-64.432H386.487 V1092.849z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M394.397,1243.898h182.185c0,0-29.275-21.057-38.302-19.953 c-9.026,1.103-22.996,9.625-31.237,9.955c-8.241,0.331-12.797-29.553-22.12-28.145c-9.322,1.407-16.573,27.84-20.923,25.258 c-4.351-2.582-18.368-3.702-27.068,0c-8.7,3.701-18.368-11.767-25.618-11.283 C404.064,1220.214,394.397,1243.898,394.397,1243.898z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 397.296,
    y: 1203.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.296,
    y: 1208.254,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.242
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M594.1,1257.182H385.305v-66.795H594.1V1257.182z M386.487,1256h206.431v-64.432H386.487V1256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 637.328,
    y: 1028.417,
    style: {
      fill: "#1C468A"
    },
    width: 72.766,
    height: 89.466
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 667.718,
    y: 1067.849,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1067.849,
    style: {
      fill: "#F99746"
    },
    width: 19.791,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.708,
    y: 1067.849,
    style: {
      fill: "#F99746"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1072.863,
    style: {
      fill: "#F99746"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.638,
    y: 1072.863,
    style: {
      fill: "#F99746"
    },
    width: 10.814,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.663,
    y: 1072.863,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 667.718,
    y: 1084.619,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1084.619,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.791,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.708,
    y: 1084.619,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1089.634,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.638,
    y: 1089.634,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.814,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.663,
    y: 1089.634,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 667.718,
    y: 1034.308,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1034.308,
    style: {
      fill: "#F99746"
    },
    width: 19.791,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.708,
    y: 1034.308,
    style: {
      fill: "#F99746"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1039.322,
    style: {
      fill: "#F99746"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.638,
    y: 1039.322,
    style: {
      fill: "#F99746"
    },
    width: 10.814,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.663,
    y: 1039.322,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 667.718,
    y: 1051.078,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1051.078,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.791,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.708,
    y: 1051.078,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1056.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.638,
    y: 1056.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.814,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.663,
    y: 1056.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 667.718,
    y: 1101.39,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1101.39,
    style: {
      fill: "#F99746"
    },
    width: 19.791,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.708,
    y: 1101.39,
    style: {
      fill: "#F99746"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.972,
    y: 1106.404,
    style: {
      fill: "#F99746"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.638,
    y: 1106.404,
    style: {
      fill: "#F99746"
    },
    width: 10.814,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.663,
    y: 1106.404,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.736
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 783.846,
    y: 1080.015,
    style: {
      fill: "#1C468A"
    },
    width: 46.563,
    height: 57.249
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 803.292,
    y: 1105.246,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1105.246,
    style: {
      fill: "#F99746"
    },
    width: 12.664,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814.165,
    y: 1105.246,
    style: {
      fill: "#F99746"
    },
    width: 11.165,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1108.456,
    style: {
      fill: "#F99746"
    },
    width: 14.669,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.161,
    y: 1108.456,
    style: {
      fill: "#F99746"
    },
    width: 6.919,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813.496,
    y: 1108.456,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.11
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 803.292,
    y: 1115.979,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.11
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1115.979,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.664,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814.165,
    y: 1115.979,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.165,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1119.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.669,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.161,
    y: 1119.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.919,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813.496,
    y: 1119.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.111
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 803.292,
    y: 1083.783,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1083.783,
    style: {
      fill: "#F99746"
    },
    width: 12.664,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814.165,
    y: 1083.783,
    style: {
      fill: "#F99746"
    },
    width: 11.165,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1086.992,
    style: {
      fill: "#F99746"
    },
    width: 14.669,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.161,
    y: 1086.992,
    style: {
      fill: "#F99746"
    },
    width: 6.919,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813.496,
    y: 1086.992,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 803.292,
    y: 1094.515,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1094.515,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.664,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814.165,
    y: 1094.515,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.165,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1097.725,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.669,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.161,
    y: 1097.725,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.919,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813.496,
    y: 1097.725,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.11
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 803.292,
    y: 1126.71,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.11
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1126.71,
    style: {
      fill: "#F99746"
    },
    width: 12.664,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814.165,
    y: 1126.71,
    style: {
      fill: "#F99746"
    },
    width: 11.165,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.098,
    y: 1129.919,
    style: {
      fill: "#F99746"
    },
    width: 14.669,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.161,
    y: 1129.919,
    style: {
      fill: "#F99746"
    },
    width: 6.919,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813.496,
    y: 1129.919,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 637.659,
    y: 1147.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.612,
    height: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.659,
    y: 1155.945,
    style: {
      fill: "#FFFFFF"
    },
    width: 39.313,
    height: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.497,
    y: 1155.945,
    style: {
      fill: "#FFFFFF"
    },
    width: 39.313,
    height: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 724.472,
    y: 1147.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.666,
    height: 2.528
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760.05,
    y: 1147.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.479,
    height: 2.528
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2505.479,
    y: 1017.525,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2507.772,
    y: 1020.134,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2757.952,
    y: 1017.525,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2760.245,
    y: 1020.134,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1027.139,
    style: {
      fill: "#F99746"
    },
    width: 18.44,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.669,
    y: 1027.139,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1031.048,
    style: {
      fill: "#F99746"
    },
    width: 11.452,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2932.052,
    y: 1031.048,
    style: {
      fill: "#F99746"
    },
    width: 11.452,
    height: 1.743
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1039.646,
    style: {
      fill: "#F99746"
    },
    width: 18.44,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.669,
    y: 1039.646,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1043.556,
    style: {
      fill: "#F99746"
    },
    width: 11.452,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2932.052,
    y: 1043.556,
    style: {
      fill: "#F99746"
    },
    width: 11.452,
    height: 1.742
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1053.268,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.44,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.669,
    y: 1053.268,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.898,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1057.176,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.452,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2932.052,
    y: 1057.176,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.452,
    height: 1.743
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1068.73,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.44,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.669,
    y: 1068.73,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.898,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2919.022,
    y: 1072.64,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.452,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2932.052,
    y: 1072.64,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.452,
    height: 1.743
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2505.479,
    y: 1181.646,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2507.772,
    y: 1184.254,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2757.952,
    y: 1181.646,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2760.245,
    y: 1184.254,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2525.953,
    y: 1273.438,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.705,
    height: 45.764
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.898,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2557.844,
    y: 1275.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 43.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2573.788,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 53.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2589.733,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2605.678,
    y: 1291.791,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 27.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2632.979,
    y: 1273.438,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 45.764
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2648.924,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2664.868,
    y: 1275.889,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 43.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2680.813,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 53.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2696.758,
    y: 1283.857,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 35.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2712.703,
    y: 1291.791,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.704,
    height: 27.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.578,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2560.468,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2573.481,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.644,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.578,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2560.468,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2573.481,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.644,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.453,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2566.51,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.626,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.453,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2566.51,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.626,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.578,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2560.468,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2573.481,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.644,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.453,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2566.51,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.626,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2541.578,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.568,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2560.468,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.2,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2573.481,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.644,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2523.718,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.453,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2566.51,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.626,
    height: 2.227
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2618.483,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2637.373,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2650.387,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2618.483,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2637.373,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2650.387,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2627.358,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.414,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2627.358,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.414,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2618.483,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2637.373,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2650.387,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2627.358,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.414,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2618.483,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2637.373,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2650.387,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.643,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2600.622,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2627.358,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.414,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2688.599,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2707.488,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2720.502,
    y: 1113.012,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.642,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2688.599,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2707.488,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2720.502,
    y: 1122.512,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.642,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2697.474,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2713.529,
    y: 1107.816,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2697.474,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2713.529,
    y: 1117.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2688.599,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2707.488,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2720.502,
    y: 1132.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.642,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2697.474,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2713.529,
    y: 1127.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.911,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2688.599,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.567,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2707.488,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.199,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2720.502,
    y: 1140.919,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.642,
    height: 2.227
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2670.737,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.411,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2697.474,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.071,
    height: 2.227
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2713.529,
    y: 1136.324,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.627,
    height: 2.227
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1031.057,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1038.016,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1027.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1027.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1027.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1034.65,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1034.65,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1034.65,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1044.975,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1041.609,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1041.609,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1041.609,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1051.499,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1048.134,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1048.134,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1048.134,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1064.598,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1071.557,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1060.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1060.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1060.792,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1068.191,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1068.191,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1068.191,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1078.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1075.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1075.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1075.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1085.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1081.675,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1081.675,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1081.675,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1097.271,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1104.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1093.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1093.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1093.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1100.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1100.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1100.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1111.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1107.823,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1107.823,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.632
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1107.823,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2872.533,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2886.668,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.382,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2896.407,
    y: 1117.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.468,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2859.167,
    y: 1114.348,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2879.174,
    y: 1114.348,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2891.189,
    y: 1114.348,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1213.231,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1220.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1209.426,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1209.426,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1209.426,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1216.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1216.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1216.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1227.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1223.784,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1223.784,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1223.784,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1233.674,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1230.309,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1230.309,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1230.309,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1265.587,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1272.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1261.781,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1261.781,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1261.781,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1269.181,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1269.181,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1269.181,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1279.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1276.14,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1276.14,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1276.14,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.906,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2950.192,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.146,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2964.328,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.381,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2974.066,
    y: 1286.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.469,
    height: 1.631
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2936.827,
    y: 1282.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.268,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2956.834,
    y: 1282.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.53,
    height: 1.631
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2968.85,
    y: 1282.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.693,
    height: 1.631
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2909.813,1235.298H2782.01c0,0,20.536-14.771,26.868-13.998s16.132,6.752,21.913,6.984 c5.781,0.231,8.978-20.731,15.517-19.744c6.54,0.988,11.626,19.53,14.678,17.719s12.885-2.597,18.988,0 s12.885-8.254,17.971-7.915S2909.813,1235.298,2909.813,1235.298z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2784.044,
    y: 1204.046,
    style: {
      fill: "#F99746"
    },
    width: 24.41,
    height: 1.573
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2784.044,
    y: 1207.404,
    style: {
      fill: "#F99746"
    },
    width: 24.41,
    height: 1.573
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2529.14,1080.747h182.186c0,0-29.275-21.057-38.302-19.953 c-9.026,1.103-22.996,9.625-31.237,9.956c-8.241,0.33-12.797-29.554-22.12-28.146c-9.322,1.407-16.572,27.84-20.923,25.258 s-18.367-3.702-27.067,0c-8.701,3.701-18.368-11.767-25.618-11.283C2538.807,1057.063,2529.14,1080.747,2529.14,1080.747z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2532.04,
    y: 1040.313,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2532.04,
    y: 1045.102,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.243
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2728.844,1094.03h-208.795v-66.795h208.795V1094.03z M2521.23,1092.849h206.431v-64.432H2521.23 V1092.849z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2529.14,1243.898h182.186c0,0-29.275-21.057-38.302-19.953 c-9.026,1.103-22.996,9.625-31.237,9.955c-8.241,0.331-12.797-29.553-22.12-28.145c-9.322,1.407-16.572,27.84-20.923,25.258 s-18.367-3.702-27.067,0c-8.701,3.701-18.368-11.767-25.618-11.283C2538.807,1220.214,2529.14,1243.898,2529.14,1243.898z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2532.04,
    y: 1203.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2532.04,
    y: 1208.254,
    style: {
      fill: "#FFFFFF"
    },
    width: 34.797,
    height: 2.242
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2728.844,1257.182h-208.795v-66.795h208.795V1257.182z M2521.23,1256h206.431v-64.432H2521.23 V1256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2772.071,
    y: 1028.417,
    style: {
      fill: "#1C468A"
    },
    width: 72.766,
    height: 89.466
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2802.461,
    y: 1067.849,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1067.849,
    style: {
      fill: "#F99746"
    },
    width: 19.79,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2819.451,
    y: 1067.849,
    style: {
      fill: "#F99746"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1072.863,
    style: {
      fill: "#F99746"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2805.381,
    y: 1072.863,
    style: {
      fill: "#F99746"
    },
    width: 10.813,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2818.406,
    y: 1072.863,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2802.461,
    y: 1084.619,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1084.619,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.79,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2819.451,
    y: 1084.619,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1089.634,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2805.381,
    y: 1089.634,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.813,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2818.406,
    y: 1089.634,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2802.461,
    y: 1034.308,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1034.308,
    style: {
      fill: "#F99746"
    },
    width: 19.79,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2819.451,
    y: 1034.308,
    style: {
      fill: "#F99746"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1039.322,
    style: {
      fill: "#F99746"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2805.381,
    y: 1039.322,
    style: {
      fill: "#F99746"
    },
    width: 10.813,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2818.406,
    y: 1039.322,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2802.461,
    y: 1051.078,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1051.078,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.79,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2819.451,
    y: 1051.078,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1056.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2805.381,
    y: 1056.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.813,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2818.406,
    y: 1056.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.733,
    height: 1.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2802.461,
    y: 1101.39,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.735
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1101.39,
    style: {
      fill: "#F99746"
    },
    width: 19.79,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2819.451,
    y: 1101.39,
    style: {
      fill: "#F99746"
    },
    width: 17.449,
    height: 1.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2778.716,
    y: 1106.404,
    style: {
      fill: "#F99746"
    },
    width: 22.923,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2805.381,
    y: 1106.404,
    style: {
      fill: "#F99746"
    },
    width: 10.813,
    height: 1.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2818.406,
    y: 1106.404,
    style: {
      fill: "#F99746"
    },
    width: 13.733,
    height: 1.736
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2918.589,
    y: 1080.015,
    style: {
      fill: "#1C468A"
    },
    width: 46.563,
    height: 57.249
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2938.036,
    y: 1105.246,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1105.246,
    style: {
      fill: "#F99746"
    },
    width: 12.664,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.908,
    y: 1105.246,
    style: {
      fill: "#F99746"
    },
    width: 11.166,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1108.456,
    style: {
      fill: "#F99746"
    },
    width: 14.669,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.904,
    y: 1108.456,
    style: {
      fill: "#F99746"
    },
    width: 6.92,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.239,
    y: 1108.456,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.11
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2938.036,
    y: 1115.979,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.11
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1115.979,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.664,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.908,
    y: 1115.979,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.166,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1119.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.669,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.904,
    y: 1119.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.92,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.239,
    y: 1119.188,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.111
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2938.036,
    y: 1083.783,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1083.783,
    style: {
      fill: "#F99746"
    },
    width: 12.664,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.908,
    y: 1083.783,
    style: {
      fill: "#F99746"
    },
    width: 11.166,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1086.992,
    style: {
      fill: "#F99746"
    },
    width: 14.669,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.904,
    y: 1086.992,
    style: {
      fill: "#F99746"
    },
    width: 6.92,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.239,
    y: 1086.992,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2938.036,
    y: 1094.515,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1094.515,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.664,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.908,
    y: 1094.515,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.166,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1097.725,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.669,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.904,
    y: 1097.725,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.92,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.239,
    y: 1097.725,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.788,
    height: 1.11
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2938.036,
    y: 1126.71,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.11
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1126.71,
    style: {
      fill: "#F99746"
    },
    width: 12.664,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.908,
    y: 1126.71,
    style: {
      fill: "#F99746"
    },
    width: 11.166,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2922.841,
    y: 1129.919,
    style: {
      fill: "#F99746"
    },
    width: 14.669,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2939.904,
    y: 1129.919,
    style: {
      fill: "#F99746"
    },
    width: 6.92,
    height: 1.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2948.239,
    y: 1129.919,
    style: {
      fill: "#F99746"
    },
    width: 8.788,
    height: 1.111
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2772.402,
    y: 1147.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.611,
    height: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2772.402,
    y: 1155.945,
    style: {
      fill: "#FFFFFF"
    },
    width: 39.313,
    height: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2817.24,
    y: 1155.945,
    style: {
      fill: "#FFFFFF"
    },
    width: 39.313,
    height: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2859.215,
    y: 1147.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.666,
    height: 2.528
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2894.793,
    y: 1147.841,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.479,
    height: 2.528
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1414.268,
    y: 1017.525,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1416.561,
    y: 1020.134,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1433.596,
    y: 1033.203,
    style: {
      fill: "#FFFFFF"
    },
    width: 73.575,
    height: 3.996
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1471.999,
    y: 1048.567,
    style: {
      fill: "#FFFFFF"
    },
    width: 49.205,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1048.567,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.659,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1053.02,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.726,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1454.021,
    y: 1053.02,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1485.003,
    y: 1053.02,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.998
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1471.999,
    y: 1069.322,
    style: {
      fill: "#FFFFFF"
    },
    width: 49.205,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1069.322,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.659,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1073.774,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.726,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1454.021,
    y: 1073.774,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1485.003,
    y: 1073.774,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.999
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1471.999,
    y: 1091.711,
    style: {
      fill: "#FFFFFF"
    },
    width: 49.205,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1091.711,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.659,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1096.163,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.726,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1454.021,
    y: 1096.163,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1485.003,
    y: 1096.163,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.999
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1471.999,
    y: 1111.966,
    style: {
      fill: "#FFFFFF"
    },
    width: 49.205,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1111.966,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.659,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1116.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.726,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1454.021,
    y: 1116.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1485.003,
    y: 1116.418,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.998
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1471.999,
    y: 1135.578,
    style: {
      fill: "#FFFFFF"
    },
    width: 49.205,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1135.578,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.659,
    height: 1.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.914,
    y: 1140.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.726,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1454.021,
    y: 1140.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1485.003,
    y: 1140.029,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.791,
    height: 1.999
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1538.377,
    y: 1032.756,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1559.023,
    y: 1032.756,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1538.377,
    y: 1036.664,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1551.406,
    y: 1036.664,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.743
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1606.692,
    y: 1114.025,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1627.339,
    y: 1114.025,
    style: {
      fill: "#F99746"
    },
    width: 13.897,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1606.692,
    y: 1117.934,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1619.722,
    y: 1117.934,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1606.692,
    y: 1129.603,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1627.339,
    y: 1129.603,
    style: {
      fill: "#F99746"
    },
    width: 13.897,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1606.692,
    y: 1133.512,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1619.722,
    y: 1133.512,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1606.692,
    y: 1144.588,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1627.339,
    y: 1144.588,
    style: {
      fill: "#F99746"
    },
    width: 13.897,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1606.692,
    y: 1148.496,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1619.722,
    y: 1148.496,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1666.741,
    y: 1017.525,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1669.033,
    y: 1020.134,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1414.268,
    y: 1181.646,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1416.561,
    y: 1184.254,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1666.741,
    y: 1181.646,
    style: {
      fill: "#4C64A5"
    },
    width: 238.669,
    height: 153.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1669.033,
    y: 1184.254,
    style: {
      fill: "#AEC3FF"
    },
    width: 234.084,
    height: 147.794
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1679.589,1223.896h110.937c0,0-17.826-12.822-23.322-12.15 c-5.497,0.671-14.003,5.861-19.021,6.063c-5.018,0.201-7.792-17.996-13.469-17.139c-5.677,0.857-10.092,16.952-12.741,15.38 c-2.648-1.572-11.184-2.254-16.481,0c-5.299,2.254-11.185-7.164-15.6-6.87S1679.589,1223.896,1679.589,1223.896z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.354,
    y: 1199.274,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.189,
    height: 1.365
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1681.354,
    y: 1202.189,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.189,
    height: 1.366
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1609.274,1318.814h-176.824v-123.946h176.824V1318.814z M1433.699,1317.566h174.328v-121.45 h-174.328V1317.566z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1596.275,1301.82h-156.822c0,0,25.2-18.126,32.97-17.176c7.77,0.949,19.794,8.285,26.888,8.569 c7.094,0.285,11.016-25.438,19.041-24.228c8.024,1.213,14.266,23.965,18.01,21.742s15.811-3.187,23.3,0 c7.489,3.186,15.811-10.128,22.051-9.712C1587.954,1281.433,1596.275,1301.82,1596.275,1301.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1441.95,
    y: 1263.472,
    style: {
      fill: "#F99746"
    },
    width: 29.953,
    height: 1.931
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1441.95,
    y: 1267.594,
    style: {
      fill: "#F99746"
    },
    width: 29.953,
    height: 1.93
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1439.453,1239.69h156.822c0,0-25.2-18.125-32.97-17.176c-7.77,0.949-19.794,8.285-26.888,8.569 c-7.094,0.285-11.016-25.438-19.041-24.227c-8.024,1.212-14.266,23.964-18.01,21.741s-15.811-3.187-23.3,0 c-7.489,3.187-15.81-10.128-22.051-9.712S1439.453,1239.69,1439.453,1239.69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1441.95,
    y: 1204.886,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.953,
    height: 1.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1441.95,
    y: 1209.008,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.953,
    height: 1.93
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1749.104,
    y: 1031.651,
    style: {
      fill: "#1C468A"
    },
    width: 59.236,
    height: 38.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1770.908,
    y: 1035.581,
    style: {
      fill: "#F99746"
    },
    width: 10.844,
    height: 1.309
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1752.159,
    y: 1035.581,
    style: {
      fill: "#F99746"
    },
    width: 15.626,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.322,
    y: 1035.581,
    style: {
      fill: "#F99746"
    },
    width: 13.777,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1752.159,
    y: 1039.365,
    style: {
      fill: "#F99746"
    },
    width: 18.1,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.214,
    y: 1039.365,
    style: {
      fill: "#F99746"
    },
    width: 8.538,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1783.498,
    y: 1039.365,
    style: {
      fill: "#F99746"
    },
    width: 10.843,
    height: 1.31
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1770.908,
    y: 1047.297,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.844,
    height: 1.309
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1752.159,
    y: 1047.297,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.626,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.322,
    y: 1047.297,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.777,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1752.159,
    y: 1051.08,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.1,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.214,
    y: 1051.08,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.538,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1783.498,
    y: 1051.08,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.843,
    height: 1.311
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1770.908,
    y: 1059.449,
    style: {
      fill: "#F99746"
    },
    width: 10.844,
    height: 1.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1752.159,
    y: 1059.449,
    style: {
      fill: "#F99746"
    },
    width: 15.626,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1784.322,
    y: 1059.449,
    style: {
      fill: "#F99746"
    },
    width: 13.777,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1752.159,
    y: 1063.232,
    style: {
      fill: "#F99746"
    },
    width: 18.1,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.214,
    y: 1063.232,
    style: {
      fill: "#F99746"
    },
    width: 8.538,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1783.498,
    y: 1063.232,
    style: {
      fill: "#F99746"
    },
    width: 10.843,
    height: 1.311
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1539.834,
    y: 1112.921,
    style: {
      fill: "#1C468A"
    },
    width: 59.236,
    height: 38.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1561.639,
    y: 1116.851,
    style: {
      fill: "#F99746"
    },
    width: 10.843,
    height: 1.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1542.89,
    y: 1116.851,
    style: {
      fill: "#F99746"
    },
    width: 15.626,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1575.053,
    y: 1116.851,
    style: {
      fill: "#F99746"
    },
    width: 13.777,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.89,
    y: 1120.635,
    style: {
      fill: "#F99746"
    },
    width: 18.1,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1563.944,
    y: 1120.635,
    style: {
      fill: "#F99746"
    },
    width: 8.538,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1574.229,
    y: 1120.635,
    style: {
      fill: "#F99746"
    },
    width: 10.843,
    height: 1.309
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1561.639,
    y: 1128.566,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.843,
    height: 1.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1542.89,
    y: 1128.566,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.626,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1575.053,
    y: 1128.566,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.777,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.89,
    y: 1132.35,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.1,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1563.944,
    y: 1132.35,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.538,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1574.229,
    y: 1132.35,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.843,
    height: 1.311
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1561.639,
    y: 1140.719,
    style: {
      fill: "#F99746"
    },
    width: 10.843,
    height: 1.309
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1542.89,
    y: 1140.719,
    style: {
      fill: "#F99746"
    },
    width: 15.626,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1575.053,
    y: 1140.719,
    style: {
      fill: "#F99746"
    },
    width: 13.777,
    height: 1.309
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.89,
    y: 1144.502,
    style: {
      fill: "#F99746"
    },
    width: 18.1,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1563.944,
    y: 1144.502,
    style: {
      fill: "#F99746"
    },
    width: 8.538,
    height: 1.311
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1574.229,
    y: 1144.502,
    style: {
      fill: "#F99746"
    },
    width: 10.843,
    height: 1.311
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1036.279,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1036.279,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1036.279,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1036.279,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1044.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1044.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1044.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1044.013,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1032.049,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1032.049,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1032.049,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1040.272,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1040.272,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1040.272,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1051.746,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1051.746,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1051.746,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1051.746,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1048.007,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1048.007,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1048.007,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1058.997,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1058.997,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1058.997,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1058.997,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1055.257,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1055.257,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1055.257,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1081.472,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1081.472,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1081.472,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1081.472,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1089.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1089.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1089.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1089.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1077.242,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1077.242,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1077.242,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1085.466,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1085.466,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1085.466,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1096.939,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1096.939,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1096.939,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1096.939,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1093.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1093.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1093.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1104.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1104.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1104.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1104.19,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1100.45,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1100.45,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1100.45,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1124.694,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1124.694,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1124.694,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1124.694,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1132.429,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1132.429,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1132.429,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1132.429,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1120.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1120.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1120.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1128.688,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1128.688,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1128.688,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1140.162,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1140.162,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1140.162,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1140.162,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1136.423,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1136.423,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1136.423,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1147.413,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.861,
    y: 1147.413,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1709.571,
    y: 1147.413,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.394,
    y: 1147.413,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1679.008,
    y: 1143.673,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.242,
    y: 1143.673,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.596,
    y: 1143.673,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.996,
    height: 1.813
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1680.408,
    y: 1246.42,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.528,
    height: 38.112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1693.389,
    y: 1255.098,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.528,
    height: 29.434
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1706.369,
    y: 1248.462,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.528,
    height: 36.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1719.35,
    y: 1239.882,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.527,
    height: 44.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1732.329,
    y: 1255.098,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.528,
    height: 29.434
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745.31,
    y: 1261.705,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.528,
    height: 22.827
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1801.521,
    y: 1269.08,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.124,
    height: 52.132
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1816.675,
    y: 1280.828,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.124,
    height: 40.384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1831.829,
    y: 1279.098,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.125,
    height: 42.114
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1846.984,
    y: 1289.177,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.124,
    height: 32.035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1862.139,
    y: 1286.845,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.125,
    height: 34.367
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1877.294,
    y: 1294.56,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.124,
    height: 26.652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1538.571,
    y: 1046.371,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.537,
    height: 58.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1555.649,
    y: 1059.61,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.537,
    height: 45.511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1572.728,
    y: 1057.66,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.537,
    height: 47.461
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1589.807,
    y: 1069.02,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.537,
    height: 36.102
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1606.886,
    y: 1066.392,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.536,
    height: 38.729
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1623.965,
    y: 1075.086,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.536,
    height: 30.035
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1743.333,
    y: 1292.006,
    style: {
      fill: "#1C468A"
    },
    width: 45.169,
    height: 29.593
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1759.959,
    y: 1295.002,
    style: {
      fill: "#F99746"
    },
    width: 8.268,
    height: 0.999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1745.663,
    y: 1295.002,
    style: {
      fill: "#F99746"
    },
    width: 11.915,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770.188,
    y: 1295.002,
    style: {
      fill: "#F99746"
    },
    width: 10.505,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745.663,
    y: 1297.888,
    style: {
      fill: "#F99746"
    },
    width: 13.802,
    height: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1761.717,
    y: 1297.888,
    style: {
      fill: "#F99746"
    },
    width: 6.511,
    height: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1769.56,
    y: 1297.888,
    style: {
      fill: "#F99746"
    },
    width: 8.267,
    height: 0.998
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1759.959,
    y: 1303.936,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.268,
    height: 0.999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1745.663,
    y: 1303.936,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.915,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770.188,
    y: 1303.936,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.505,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745.663,
    y: 1306.82,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.802,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1761.717,
    y: 1306.82,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.511,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1769.56,
    y: 1306.82,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.267,
    height: 0.999
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1759.959,
    y: 1313.201,
    style: {
      fill: "#F99746"
    },
    width: 8.268,
    height: 0.999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1745.663,
    y: 1313.201,
    style: {
      fill: "#F99746"
    },
    width: 11.915,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770.188,
    y: 1313.201,
    style: {
      fill: "#F99746"
    },
    width: 10.505,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745.663,
    y: 1316.087,
    style: {
      fill: "#F99746"
    },
    width: 13.802,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1761.717,
    y: 1316.087,
    style: {
      fill: "#F99746"
    },
    width: 6.511,
    height: 0.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1769.56,
    y: 1316.087,
    style: {
      fill: "#F99746"
    },
    width: 8.267,
    height: 0.999
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1296.942,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1695.96,
    y: 1296.942,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1711.67,
    y: 1296.942,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1722.492,
    y: 1296.942,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1304.677,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1695.96,
    y: 1304.677,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1711.67,
    y: 1304.677,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1722.492,
    y: 1304.677,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1292.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1703.341,
    y: 1292.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1716.694,
    y: 1292.713,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1300.937,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1703.341,
    y: 1300.937,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1716.694,
    y: 1300.937,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1312.41,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1695.96,
    y: 1312.41,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1711.67,
    y: 1312.41,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1722.492,
    y: 1312.41,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1308.67,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1703.341,
    y: 1308.67,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1716.694,
    y: 1308.67,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1319.661,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.231,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1695.96,
    y: 1319.661,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1711.67,
    y: 1319.661,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1722.492,
    y: 1319.661,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1681.106,
    y: 1315.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.301,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1703.341,
    y: 1315.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1716.694,
    y: 1315.921,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1235.676,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1235.676,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1235.676,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1235.676,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1243.409,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1243.409,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1243.409,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1243.409,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1231.446,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1231.446,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1231.446,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1239.669,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1239.669,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1239.669,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1251.144,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1251.144,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1251.144,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1251.144,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1247.403,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1247.403,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1247.403,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1258.394,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1258.394,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1258.394,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1258.394,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1254.653,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1254.653,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1254.653,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.814
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1198.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1198.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1198.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1198.762,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1206.496,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1206.496,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1206.496,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1206.496,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1194.532,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1194.532,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1194.532,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1202.756,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1202.756,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1202.756,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1214.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1214.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1214.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1214.229,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1210.49,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1210.49,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1210.49,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1221.48,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.233,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.361,
    y: 1221.48,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.61,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1834.07,
    y: 1221.48,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.314,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1844.894,
    y: 1221.48,
    style: {
      fill: "#FFFFFF"
    },
    width: 7.188,
    height: 1.813
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1803.507,
    y: 1217.74,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.302,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.742,
    y: 1217.74,
    style: {
      fill: "#FFFFFF"
    },
    width: 11.702,
    height: 1.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.096,
    y: 1217.74,
    style: {
      fill: "#FFFFFF"
    },
    width: 12.995,
    height: 1.813
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 1752.159,
    y: 1088.419,
    style: {
      fill: "#FFFFFF"
    },
    width: 136.259,
    height: 63.721
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1094.114,
    style: {
      fill: "#F99746"
    },
    width: 21.277,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.482,
    y: 1094.114,
    style: {
      fill: "#F99746"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1098.624,
    style: {
      fill: "#F99746"
    },
    width: 13.215,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.693,
    y: 1098.624,
    style: {
      fill: "#F99746"
    },
    width: 13.215,
    height: 2.011
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1107.831,
    style: {
      fill: "#1C468A"
    },
    width: 21.277,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.482,
    y: 1107.831,
    style: {
      fill: "#1C468A"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1112.342,
    style: {
      fill: "#1C468A"
    },
    width: 13.215,
    height: 2.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.693,
    y: 1112.342,
    style: {
      fill: "#1C468A"
    },
    width: 13.215,
    height: 2.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1122.304,
    style: {
      fill: "#AEC3FF"
    },
    width: 21.277,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.482,
    y: 1122.304,
    style: {
      fill: "#AEC3FF"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1126.813,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.693,
    y: 1126.813,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1137.152,
    style: {
      fill: "#AEC3FF"
    },
    width: 21.277,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.482,
    y: 1137.152,
    style: {
      fill: "#AEC3FF"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1758.66,
    y: 1141.662,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.693,
    y: 1141.662,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1094.114,
    style: {
      fill: "#F99746"
    },
    width: 21.278,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1838.769,
    y: 1094.114,
    style: {
      fill: "#F99746"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1098.624,
    style: {
      fill: "#F99746"
    },
    width: 13.215,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1829.979,
    y: 1098.624,
    style: {
      fill: "#F99746"
    },
    width: 13.215,
    height: 2.011
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1107.831,
    style: {
      fill: "#1C468A"
    },
    width: 21.278,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1838.769,
    y: 1107.831,
    style: {
      fill: "#1C468A"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1112.342,
    style: {
      fill: "#1C468A"
    },
    width: 13.215,
    height: 2.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1829.979,
    y: 1112.342,
    style: {
      fill: "#1C468A"
    },
    width: 13.215,
    height: 2.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1122.304,
    style: {
      fill: "#AEC3FF"
    },
    width: 21.278,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1838.769,
    y: 1122.304,
    style: {
      fill: "#AEC3FF"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1126.813,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1829.979,
    y: 1126.813,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1137.152,
    style: {
      fill: "#AEC3FF"
    },
    width: 21.278,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1838.769,
    y: 1137.152,
    style: {
      fill: "#AEC3FF"
    },
    width: 16.035,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1814.946,
    y: 1141.662,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1829.979,
    y: 1141.662,
    style: {
      fill: "#AEC3FF"
    },
    width: 13.215,
    height: 2.011
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1829.514,
    y: 1033.203,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1850.16,
    y: 1033.203,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1829.514,
    y: 1037.111,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1842.543,
    y: 1037.111,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.743
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1829.514,
    y: 1046.993,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1850.16,
    y: 1046.993,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1829.514,
    y: 1050.902,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1842.543,
    y: 1050.902,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1829.514,
    y: 1061.717,
    style: {
      fill: "#F99746"
    },
    width: 18.441,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1850.16,
    y: 1061.717,
    style: {
      fill: "#F99746"
    },
    width: 13.898,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1829.514,
    y: 1065.626,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1842.543,
    y: 1065.626,
    style: {
      fill: "#F99746"
    },
    width: 11.453,
    height: 1.742
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1390.192,
    style: {
      fill: "#AFCDFB"
    },
    width: 335.631,
    height: 73.614
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1057.433,1405.708c0-3.301,2.676-5.978,5.977-5.978s5.978,2.677,5.978,5.978 c0,3.302-2.676,5.978-5.978,5.978S1057.433,1409.01,1057.433,1405.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1079.086,1405.708c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 c0,3.302-2.676,5.978-5.977,5.978S1079.086,1409.01,1079.086,1405.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1130.514,1405.708c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 c0,3.302-2.676,5.978-5.977,5.978S1130.514,1409.01,1130.514,1405.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1102.77,1405.708c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 c0,3.302-2.676,5.978-5.977,5.978S1102.77,1409.01,1102.77,1405.708z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1316.578,
    style: {
      fill: "#AFCDFB"
    },
    width: 335.631,
    height: 73.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1241.929,
    style: {
      fill: "#AFCDFB"
    },
    width: 335.631,
    height: 73.613
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1057.433,1331.621c0-3.301,2.676-5.978,5.977-5.978s5.978,2.677,5.978,5.978 s-2.676,5.978-5.978,5.978S1057.433,1334.922,1057.433,1331.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1079.086,1331.621c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 s-2.676,5.978-5.977,5.978S1079.086,1334.922,1079.086,1331.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1130.514,1331.621c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 s-2.676,5.978-5.977,5.978S1130.514,1334.922,1130.514,1331.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1102.77,1331.621c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 s-2.676,5.978-5.977,5.978S1102.77,1334.922,1102.77,1331.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1057.433,1257.534c0-3.302,2.676-5.978,5.977-5.978s5.978,2.676,5.978,5.978 c0,3.301-2.676,5.977-5.978,5.977S1057.433,1260.835,1057.433,1257.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1079.086,1257.534c0-3.302,2.676-5.978,5.978-5.978s5.977,2.676,5.977,5.978 c0,3.301-2.676,5.977-5.977,5.977S1079.086,1260.835,1079.086,1257.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1130.514,1257.534c0-3.302,2.676-5.978,5.978-5.978s5.977,2.676,5.977,5.978 c0,3.301-2.676,5.977-5.977,5.977S1130.514,1260.835,1130.514,1257.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1102.77,1257.534c0-3.302,2.676-5.978,5.978-5.978s5.977,2.676,5.977,5.978 c0,3.301-2.676,5.977-5.977,5.977S1102.77,1260.835,1102.77,1257.534z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1385.972,
    style: {
      fill: "#060633"
    },
    width: 335.631,
    height: 0.902
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1315.542,
    style: {
      fill: "#060633"
    },
    width: 335.631,
    height: 0.902
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1241.477,
    style: {
      fill: "#060633"
    },
    width: 335.631,
    height: 0.902
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1166.926,
    style: {
      fill: "#AFCDFB"
    },
    width: 335.631,
    height: 74.551
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1057.433,1183.913c0-3.301,2.676-5.977,5.977-5.977s5.978,2.676,5.978,5.977 c0,3.302-2.676,5.978-5.978,5.978S1057.433,1187.215,1057.433,1183.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1079.086,1183.913c0-3.301,2.676-5.977,5.978-5.977s5.977,2.676,5.977,5.977 c0,3.302-2.676,5.978-5.977,5.978S1079.086,1187.215,1079.086,1183.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1130.514,1183.913c0-3.301,2.676-5.977,5.978-5.977s5.977,2.676,5.977,5.977 c0,3.302-2.676,5.978-5.977,5.978S1130.514,1187.215,1130.514,1183.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1102.77,1183.913c0-3.301,2.676-5.977,5.978-5.977s5.977,2.676,5.977,5.977 c0,3.302-2.676,5.978-5.977,5.978S1102.77,1187.215,1102.77,1183.913z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1093.312,
    style: {
      fill: "#AFCDFB"
    },
    width: 335.631,
    height: 73.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1020.134,
    style: {
      fill: "#AFCDFB"
    },
    width: 335.631,
    height: 73.614
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1057.433,1109.826c0-3.301,2.676-5.978,5.977-5.978s5.978,2.677,5.978,5.978 s-2.676,5.978-5.978,5.978S1057.433,1113.127,1057.433,1109.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1079.086,1109.826c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 s-2.676,5.978-5.977,5.978S1079.086,1113.127,1079.086,1109.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1130.514,1109.826c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 s-2.676,5.978-5.977,5.978S1130.514,1113.127,1130.514,1109.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1102.77,1109.826c0-3.301,2.676-5.978,5.978-5.978s5.977,2.677,5.977,5.978 s-2.676,5.978-5.977,5.978S1102.77,1113.127,1102.77,1109.826z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1057.433,1035.739c0-3.302,2.676-5.978,5.977-5.978s5.978,2.676,5.978,5.978 c0,3.301-2.676,5.978-5.978,5.978S1057.433,1039.04,1057.433,1035.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1079.086,1035.739c0-3.302,2.676-5.978,5.978-5.978s5.977,2.676,5.977,5.978 c0,3.301-2.676,5.978-5.977,5.978S1079.086,1039.04,1079.086,1035.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1130.514,1035.739c0-3.302,2.676-5.978,5.978-5.978s5.977,2.676,5.977,5.978 c0,3.301-2.676,5.978-5.977,5.978S1130.514,1039.04,1130.514,1035.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1102.77,1035.739c0-3.302,2.676-5.978,5.978-5.978s5.977,2.676,5.977,5.978 c0,3.301-2.676,5.978-5.977,5.978S1102.77,1039.04,1102.77,1035.739z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1164.177,
    style: {
      fill: "#060633"
    },
    width: 335.631,
    height: 0.902
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.516,
    y: 1093.748,
    style: {
      fill: "#060633"
    },
    width: 335.631,
    height: 0.901
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1411.773,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.232,
    height: 52.033
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2214.727,1422.741c0-2.334,1.892-4.226,4.225-4.226c2.334,0,4.225,1.892,4.225,4.226 c0,2.333-1.891,4.225-4.225,4.225C2216.618,1426.966,2214.727,1425.074,2214.727,1422.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2230.031,1422.741c0-2.334,1.893-4.226,4.226-4.226s4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225S2230.031,1425.074,2230.031,1422.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2266.382,1422.741c0-2.334,1.892-4.226,4.226-4.226c2.333,0,4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225C2268.273,1426.966,2266.382,1425.074,2266.382,1422.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2246.772,1422.741c0-2.334,1.892-4.226,4.225-4.226s4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225S2246.772,1425.074,2246.772,1422.741z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1359.741,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.232,
    height: 52.032
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1306.977,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.232,
    height: 52.032
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2214.727,1370.374c0-2.333,1.892-4.225,4.225-4.225c2.334,0,4.225,1.892,4.225,4.225 s-1.891,4.226-4.225,4.226C2216.618,1374.6,2214.727,1372.707,2214.727,1370.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2230.031,1370.374c0-2.333,1.893-4.225,4.226-4.225s4.225,1.892,4.225,4.225 s-1.892,4.226-4.225,4.226S2230.031,1372.707,2230.031,1370.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2266.382,1370.374c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 s-1.892,4.226-4.225,4.226C2268.273,1374.6,2266.382,1372.707,2266.382,1370.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2246.772,1370.374c0-2.333,1.892-4.225,4.225-4.225s4.225,1.892,4.225,4.225 s-1.892,4.226-4.225,4.226S2246.772,1372.707,2246.772,1370.374z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2214.727,1318.007c0-2.333,1.892-4.225,4.225-4.225c2.334,0,4.225,1.892,4.225,4.225 c0,2.334-1.891,4.226-4.225,4.226C2216.618,1322.232,2214.727,1320.341,2214.727,1318.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2230.031,1318.007c0-2.333,1.893-4.225,4.226-4.225s4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226S2230.031,1320.341,2230.031,1318.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2266.382,1318.007c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226C2268.273,1322.232,2266.382,1320.341,2266.382,1318.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.772,1318.007c0-2.333,1.892-4.225,4.225-4.225s4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226S2246.772,1320.341,2246.772,1318.007z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1408.791,
    style: {
      fill: "#060633"
    },
    width: 237.232,
    height: 0.638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1359.009,
    style: {
      fill: "#060633"
    },
    width: 237.232,
    height: 0.639
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1306.658,
    style: {
      fill: "#060633"
    },
    width: 237.232,
    height: 0.638
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1253.963,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.232,
    height: 52.695
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2214.727,1265.971c0-2.334,1.892-4.226,4.225-4.226c2.334,0,4.225,1.892,4.225,4.226 c0,2.333-1.891,4.225-4.225,4.225C2216.618,1270.195,2214.727,1268.304,2214.727,1265.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2230.031,1265.971c0-2.334,1.893-4.226,4.226-4.226s4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225S2230.031,1268.304,2230.031,1265.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2266.382,1265.971c0-2.334,1.892-4.226,4.226-4.226c2.333,0,4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225C2268.273,1270.195,2266.382,1268.304,2266.382,1265.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2246.772,1265.971c0-2.334,1.892-4.226,4.225-4.226s4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225S2246.772,1268.304,2246.772,1265.971z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1201.931,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.232,
    height: 52.032
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1150.206,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.232,
    height: 52.032
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F99746"
    },
    cx: 2218.951,
    cy: 1213.604,
    r: 4.225
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2230.031,1213.604c0-2.333,1.893-4.225,4.226-4.225s4.225,1.892,4.225,4.225 s-1.892,4.225-4.225,4.225S2230.031,1215.937,2230.031,1213.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2266.382,1213.604c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 s-1.892,4.225-4.225,4.225C2268.273,1217.828,2266.382,1215.937,2266.382,1213.604z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F99746"
    },
    cx: 2250.997,
    cy: 1213.604,
    r: 4.225
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2214.727,1161.236c0-2.333,1.892-4.225,4.225-4.225c2.334,0,4.225,1.892,4.225,4.225 c0,2.334-1.891,4.226-4.225,4.226C2216.618,1165.462,2214.727,1163.57,2214.727,1161.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2230.031,1161.236c0-2.333,1.893-4.225,4.226-4.225s4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226S2230.031,1163.57,2230.031,1161.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2266.382,1161.236c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226C2268.273,1165.462,2266.382,1163.57,2266.382,1161.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2246.772,1161.236c0-2.333,1.892-4.225,4.225-4.225s4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226S2246.772,1163.57,2246.772,1161.236z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1252.021,
    style: {
      fill: "#060633"
    },
    width: 237.232,
    height: 0.638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2202.77,
    y: 1202.238,
    style: {
      fill: "#060633"
    },
    width: 237.232,
    height: 0.638
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1411.773,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.233,
    height: 52.033
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1953.282,1422.741c0-2.334,1.892-4.226,4.226-4.226c2.333,0,4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225C1955.174,1426.966,1953.282,1425.074,1953.282,1422.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1968.588,1422.741c0-2.334,1.892-4.226,4.226-4.226c2.333,0,4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225C1970.479,1426.966,1968.588,1425.074,1968.588,1422.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2004.938,1422.741c0-2.334,1.892-4.226,4.225-4.226s4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225S2004.938,1425.074,2004.938,1422.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1985.328,1422.741c0-2.334,1.892-4.226,4.225-4.226c2.334,0,4.226,1.892,4.226,4.226 c0,2.333-1.892,4.225-4.226,4.225C1987.22,1426.966,1985.328,1425.074,1985.328,1422.741z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1359.741,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.233,
    height: 52.032
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1306.977,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.233,
    height: 52.032
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1953.282,1370.374c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 s-1.892,4.226-4.225,4.226C1955.174,1374.6,1953.282,1372.707,1953.282,1370.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1968.588,1370.374c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 s-1.892,4.226-4.225,4.226C1970.479,1374.6,1968.588,1372.707,1968.588,1370.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2004.938,1370.374c0-2.333,1.892-4.225,4.225-4.225s4.225,1.892,4.225,4.225 s-1.892,4.226-4.225,4.226S2004.938,1372.707,2004.938,1370.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1985.328,1370.374c0-2.333,1.892-4.225,4.225-4.225c2.334,0,4.226,1.892,4.226,4.225 s-1.892,4.226-4.226,4.226C1987.22,1374.6,1985.328,1372.707,1985.328,1370.374z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1953.282,1318.007c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226C1955.174,1322.232,1953.282,1320.341,1953.282,1318.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1968.588,1318.007c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226C1970.479,1322.232,1968.588,1320.341,1968.588,1318.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2004.938,1318.007c0-2.333,1.892-4.225,4.225-4.225s4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226S2004.938,1320.341,2004.938,1318.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1985.328,1318.007c0-2.333,1.892-4.225,4.225-4.225c2.334,0,4.226,1.892,4.226,4.225 c0,2.334-1.892,4.226-4.226,4.226C1987.22,1322.232,1985.328,1320.341,1985.328,1318.007z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1408.791,
    style: {
      fill: "#060633"
    },
    width: 237.233,
    height: 0.638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1359.009,
    style: {
      fill: "#060633"
    },
    width: 237.233,
    height: 0.639
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1306.658,
    style: {
      fill: "#060633"
    },
    width: 237.233,
    height: 0.638
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1253.963,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.233,
    height: 52.695
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1953.282,1265.971c0-2.334,1.892-4.226,4.226-4.226c2.333,0,4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225C1955.174,1270.195,1953.282,1268.304,1953.282,1265.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1968.588,1265.971c0-2.334,1.892-4.226,4.226-4.226c2.333,0,4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225C1970.479,1270.195,1968.588,1268.304,1968.588,1265.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2004.938,1265.971c0-2.334,1.892-4.226,4.225-4.226s4.225,1.892,4.225,4.226 c0,2.333-1.892,4.225-4.225,4.225S2004.938,1268.304,2004.938,1265.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1985.328,1265.971c0-2.334,1.892-4.226,4.225-4.226c2.334,0,4.226,1.892,4.226,4.226 c0,2.333-1.892,4.225-4.226,4.225C1987.22,1270.195,1985.328,1268.304,1985.328,1265.971z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1201.931,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.233,
    height: 52.032
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1150.206,
    style: {
      fill: "#AFCDFB"
    },
    width: 237.233,
    height: 52.032
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1953.282,1213.604c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 s-1.892,4.225-4.225,4.225C1955.174,1217.828,1953.282,1215.937,1953.282,1213.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1968.588,1213.604c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 s-1.892,4.225-4.225,4.225C1970.479,1217.828,1968.588,1215.937,1968.588,1213.604z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 2009.163,
    cy: 1213.604,
    r: 4.225
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1985.328,1213.604c0-2.333,1.892-4.225,4.225-4.225c2.334,0,4.226,1.892,4.226,4.225 s-1.892,4.225-4.226,4.225C1987.22,1217.828,1985.328,1215.937,1985.328,1213.604z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1953.282,1161.236c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226C1955.174,1165.462,1953.282,1163.57,1953.282,1161.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1968.588,1161.236c0-2.333,1.892-4.225,4.226-4.225c2.333,0,4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226C1970.479,1165.462,1968.588,1163.57,1968.588,1161.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2004.938,1161.236c0-2.333,1.892-4.225,4.225-4.225s4.225,1.892,4.225,4.225 c0,2.334-1.892,4.226-4.225,4.226S2004.938,1163.57,2004.938,1161.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1985.328,1161.236c0-2.333,1.892-4.225,4.225-4.225c2.334,0,4.226,1.892,4.226,4.225 c0,2.334-1.892,4.226-4.226,4.226C1987.22,1165.462,1985.328,1163.57,1985.328,1161.236z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1252.021,
    style: {
      fill: "#060633"
    },
    width: 237.233,
    height: 0.638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1941.325,
    y: 1202.238,
    style: {
      fill: "#060633"
    },
    width: 237.233,
    height: 0.638
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M188.169,1473.391h-6.346c-4.31,0-7.804-3.494-7.804-7.805v-115.663 c0-4.311,3.494-7.805,7.804-7.805h6.346c4.31,0,7.804,3.494,7.804,7.805v115.663 C195.974,1469.896,192.48,1473.391,188.169,1473.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M296.39,1454.518h-12.337h-65.551H174.02v8.436c0,7.164,3.169,12.972,7.08,12.972h37.402h65.551 h12.337c2.891,0,5.235-4.295,5.235-9.592v-2.224C301.625,1458.812,299.281,1454.518,296.39,1454.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M353.435,1547.938c0,0-1.803,22.395,2.208,22.691c0.533,0.039,20.338,0.039,20.338,0.039 l25.282-0.146c0,0-0.165-6.091-7.556-7.379c-7.39-1.288-22.016-7.507-26.493-17.274 C362.504,1535.595,353.435,1547.938,353.435,1547.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M201.059,1425.258c0,0,0.842,22.008,4.721,29.387h89.415c0,0,21.484,2.224,23.442,3.672 c2.472,1.828-8.605,19.962,32.917,90.83l20.339-0.518c0,0-21.267-114.934-25.046-117.843 c-5.652-4.351-71.801-19.495-83.124-19.826C252.398,1410.63,201.059,1425.258,201.059,1425.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M255.686,1304.451c6.9,4.273,7.289,12.786,7.289,12.786c-16.83,4.354-41.316-14.33-41.316-14.33 s10.833-7.279,14.846-23.272c0.203-0.808,0.388-1.635,0.551-2.481c0.526-2.693,0.852-5.61,0.911-8.757l7.731,6.925l12.855,11.518 c0,0-0.292,4.779-1.899,12.999C256.374,1301.272,256.053,1302.812,255.686,1304.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M265.191,1392.805c-0.576,3.754,0.588,6.765,1.152,9.56c0.216,1.067,0.348,2.099,0.252,3.131 c-0.216,2.471-0.18,4.426,0,6.021c0.563,5.109,2.507,6.489,1.619,9.044c0,0-3.946,2.303-11.191,5.05 c-3.155,1.199-6.933,2.471-11.275,3.67c-0.228,0.061-0.456,0.132-0.684,0.192c-16.829,4.546-34.509,5.518-39.511,5.386 c-9.548-0.264-11.467-24.458-7.929-54.924c5.518-47.476,12.979-70.481,32.626-87.118c1.247-1.044,0.408,2.519,7.017,5.709 c6.105,2.927,13.47,3.623,19.18,2.352l4.498,4.605c8.924,14.105,9.86,30.851,9.104,44.801 c-0.779,14.214-2.375,26.124-3.838,35.876C265.852,1388.498,265.516,1390.718,265.191,1392.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED975D"
    },
    d: "M258.553,1286.839c0,0,0.684-0.72-0.924,7.5c-14.239-4.119-18.877-11.373-20.779-16.183 c-0.541-1.358,5.293-2.083,8.848-2.835L258.553,1286.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M265.171,1286.879c0,0-27.474,3.935-29.66-13.213c-2.187-17.146-7.205-28.188,10.244-31.424 c17.449-3.237,21.698,2.871,23.82,8.416C271.696,1256.204,272.261,1285.414,265.171,1286.879z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 422.998,
    y: 1340.669,
    transform: "matrix(-0.9543 -0.2989 0.2989 -0.9543 419.4089 2803.1426)",
    style: {
      fill: "#1C468A"
    },
    width: 2.202,
    height: 57.648
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.069,
    y: 1393.399,
    transform: "matrix(-0.9999 -0.0104 0.0104 -0.9999 758.1308 2794.3511)",
    style: {
      fill: "#1C468A"
    },
    width: 60.495,
    height: 3.619
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3A64"
    },
    d: "M226.75,1242.588c-0.221-0.257-0.732-0.467-1.873-0.538c0,0,0.917-0.563,2.138-0.584 c0.251-1.586,1.118-4.389,3.855-5.051c0,0-1.475,0.771-1.68,2.458c3.191-3.226,9.99-5.538,28.756-3.907 c24.731,2.147,16.451,17.928,13.232,19.792c-3.219,1.863-11.242-3.379-17.215-2.952c-5.973,0.427-7.176,9.043-9.21,10.211 s-1.222-0.919-3.952-2.179c-2.73-1.26-3.026,3.277-2.258,6.236c0.768,2.958-3.027,6.821-3.027,6.821s0,0-3.772-4.127 c-3.772-4.127-7.221-21.509-5.462-25.194C226.438,1243.249,226.591,1242.919,226.75,1242.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M266.595,1405.495c-0.216,2.471-0.18,4.426,0,6.021c-38.983-8.912-40.747-62.913-40.926-63.837 l39.379,34.665c0,0,0.503,1.5,1.163,3.814c-0.359,2.339-0.695,4.559-1.02,6.646c-0.576,3.754,0.588,6.765,1.152,9.56 C266.559,1403.432,266.691,1404.463,266.595,1405.495z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M324.971,1395.089c0,0,2.52,0.409,5.181-0.84c2.66-1.249,11.836-5.189,13.56-4.651 c1.723,0.539,7.35,3.717,8.674,4.32c1.325,0.603,3.666,3.699,3.666,3.699c-0.972,0.981-4.39-1.27-5.916-1.227 c-1.526,0.043-12.804,6.203-16.156,6.338c-3.352,0.134-8.576-0.553-8.576-0.553L324.971,1395.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M345.411,1395.58c0.03,0.184,4.123,4.745,7.243,3.299l-3.419-3.377L345.411,1395.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M330.151,1394.249c0,0,3.671-3.398,4.888-5.033c0,0,0.733,0.335,0.763,0.954 c0.05,1.035-0.96,2.934-0.96,2.934L330.151,1394.249z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M257.938,1313.473c-20.178-12.289-43.994,9.182-33.98,30.58 c11.61,24.812,30.939,55.075,46.298,56.863c10.947,1.273,42.231,5.284,55.482,2.814c0,0,6.419,0.316,2.938-10.021 c0,0-42.812-11.932-49.924-21.188c-3.811-4.959-10.305-15.001-20.346-58.76C258.365,1313.583,258.094,1313.568,257.938,1313.473z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.186,
    y: 1475.925,
    style: {
      fill: "#2B478B"
    },
    width: 8.439,
    height: 100.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.241,
    y: 1572.242,
    style: {
      fill: "#2B478B"
    },
    width: 58.27,
    height: 4.426
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M208.134,1581.831c0-2.852,2.312-5.163,5.163-5.163c2.852,0,5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163C210.446,1586.994,208.134,1584.683,208.134,1581.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M255.955,1581.831c0-2.852,2.312-5.163,5.163-5.163c2.852,0,5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163C258.266,1586.994,255.955,1584.683,255.955,1581.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.249,
    y: 209.928,
    transform: "matrix(1 0.0044 -0.0044 1 0.9585 -7.0333)",
    style: {
      fill: "#1C468A"
    },
    width: 3105.37,
    height: 9.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.844,
    y: 302.137,
    transform: "matrix(1 0.0044 -0.0044 1 1.3634 -7.0306)",
    style: {
      fill: "#1C468A"
    },
    width: 3105.369,
    height: 9.596
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.026,
    y: 167.73,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 -99.7977 324.541)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440.638,
    y: 168.598,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 -9.7274 491.1988)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 638.251,
    y: 169.466,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 80.3434 657.8568)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 835.864,
    y: 170.334,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 170.4119 824.5119)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1033.476,
    y: 171.202,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 260.4831 991.1703)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1231.088,
    y: 172.069,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 350.5524 1157.8268)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1428.701,
    y: 172.937,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 440.6239 1324.4852)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1626.313,
    y: 173.805,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 530.6925 1491.141)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1823.926,
    y: 174.673,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 620.7658 1657.8011)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2021.538,
    y: 175.541,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 710.8363 1824.4583)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2219.15,
    y: 176.409,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 800.9033 1991.1127)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2416.763,
    y: 177.277,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 890.9718 2157.7688)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2614.376,
    y: 178.144,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 981.0425 2324.4265)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.815
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2811.988,
    y: 179.012,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 1071.119 2491.0886)",
    style: {
      fill: "#1C468A"
    },
    width: 8.396,
    height: 171.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3009.601,
    y: 179.88,
    transform: "matrix(0.5405 -0.8413 0.8413 0.5405 1161.1825 2657.7405)",
    style: {
      fill: "#1C468A"
    },
    width: 8.397,
    height: 171.815
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.641,
    y: 437.282,
    style: {
      fill: "#1C468A"
    },
    width: 744.327,
    height: 376.189
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.626,
    y: 447.52,
    style: {
      fill: "#AEC3FF"
    },
    width: 728.358,
    height: 355.714
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 311.358,
    y: 304.471,
    style: {
      fill: "#1C468A"
    },
    width: 10.428,
    height: 132.811
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.823,
    y: 304.471,
    style: {
      fill: "#1C468A"
    },
    width: 10.428,
    height: 132.811
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256.029,
    y: 700.943,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 78.529
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.774,
    y: 718.822,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 60.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.519,
    y: 705.149,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 74.323
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.265,
    y: 687.471,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 92.001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.01,
    y: 718.822,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 60.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.755,
    y: 732.438,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 47.035
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.942,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 771.312,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793.612,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.942,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 771.312,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793.612,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 722.89,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.151,
    y: 722.89,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.665,
    y: 722.89,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 739.833,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.151,
    y: 739.833,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.665,
    y: 739.833,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.942,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 771.312,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793.612,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 755.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.151,
    y: 755.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.665,
    y: 755.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.942,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 771.312,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793.612,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.336,
    y: 770.708,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.151,
    y: 770.708,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.665,
    y: 770.708,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 745.125,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 745.125,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 745.125,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 745.125,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 756.797,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 756.797,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 756.797,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 756.797,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 738.741,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 738.741,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 738.741,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 751.153,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 751.153,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 751.153,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 768.47,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 768.47,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 768.47,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 768.47,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 762.826,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 762.826,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 762.826,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 779.414,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 779.414,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 779.414,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 779.414,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 773.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 773.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 773.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 688.259,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 688.259,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 688.259,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 688.259,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 699.933,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 699.933,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 699.933,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 699.933,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 681.876,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 681.876,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 681.876,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 694.288,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 694.288,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 694.288,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 711.605,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 711.605,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 711.605,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 711.605,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 705.96,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 705.96,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 705.96,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 722.548,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.972,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.254,
    y: 722.548,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.052,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.964,
    y: 722.548,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.059,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.3,
    y: 722.548,
    style: {
      fill: "#FFFFFF"
    },
    width: 10.849,
    height: 2.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 453.835,
    y: 716.904,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.641,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.395,
    y: 716.904,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.662,
    height: 2.736
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.548,
    y: 716.904,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.615,
    height: 2.736
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.264,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.575,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 895.943,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.244,
    y: 731.604,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.264,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.575,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 895.943,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.244,
    y: 747.54,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 722.89,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.83,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.783,
    y: 722.89,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.296,
    y: 722.89,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 739.833,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.83,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.783,
    y: 739.833,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.296,
    y: 739.833,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.264,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.575,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 895.943,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.244,
    y: 763.475,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 755.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.83,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.783,
    y: 755.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.296,
    y: 755.769,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.264,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.575,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 895.943,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.244,
    y: 778.415,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 832.969,
    y: 770.708,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.83,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.783,
    y: 770.708,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.296,
    y: 770.708,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M940.154,535.016H725.783c0,0,34.447-24.776,45.068-23.479 c10.621,1.298,27.059,11.326,36.755,11.715c9.697,0.389,15.058-34.774,26.027-33.118c10.97,1.657,19.501,32.758,24.62,29.72 c5.119-3.039,21.612-4.356,31.85,0c10.238,4.355,21.613-13.845,30.144-13.276C928.779,507.147,940.154,535.016,940.154,535.016z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 729.196,
    y: 482.595,
    style: {
      fill: "#F99746"
    },
    width: 40.944,
    height: 2.638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 729.196,
    y: 488.229,
    style: {
      fill: "#F99746"
    },
    width: 40.944,
    height: 2.638
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C468A"
    },
    d: "M940.154,629.751H725.783c0,0,34.885-20.193,45.068-23.479 c15.759-5.085,28.678,9.314,36.755,11.715c9.303,2.765,6.15-16.845,21.743-16.845c11.094,0,23.786,16.485,28.904,13.447 c5.119-3.038,21.612-4.356,31.85,0c10.238,4.355,21.613-13.844,30.144-13.276C928.779,601.882,940.154,629.751,940.154,629.751z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 729.196,
    y: 577.331,
    style: {
      fill: "#1C468A"
    },
    width: 40.944,
    height: 2.639
  }), /*#__PURE__*/React.createElement("rect", {
    x: 729.196,
    y: 582.965,
    style: {
      fill: "#1C468A"
    },
    width: 40.944,
    height: 2.639
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.276,576.587h369.69c0,0-59.406-42.728-77.722-40.49s-46.663,19.531-63.386,20.202 c-16.723,0.671-25.967-59.969-44.885-57.112c-18.917,2.857-33.63,56.493-42.458,51.253c-8.827-5.239-37.271-7.511-54.926,0 c-17.655,7.512-37.271-23.875-51.984-22.894C292.893,528.526,273.276,576.587,273.276,576.587z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.162,
    y: 494.539,
    style: {
      fill: "#FFFFFF"
    },
    width: 70.61,
    height: 4.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.162,
    y: 504.255,
    style: {
      fill: "#FFFFFF"
    },
    width: 70.61,
    height: 4.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M678.514,603.541H254.829V468h423.685V603.541z M257.228,601.142h418.887V470.399H257.228V601.142 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 563.477,
    y: 629.751,
    style: {
      fill: "#1C468A"
    },
    width: 122.054,
    height: 150.065
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 614.453,
    y: 695.891,
    style: {
      fill: "#F99746"
    },
    width: 23.035,
    height: 2.912
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 695.891,
    style: {
      fill: "#F99746"
    },
    width: 33.196,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.95,
    y: 695.891,
    style: {
      fill: "#F99746"
    },
    width: 29.269,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 704.303,
    style: {
      fill: "#F99746"
    },
    width: 38.451,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.35,
    y: 704.303,
    style: {
      fill: "#F99746"
    },
    width: 18.138,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.198,
    y: 704.303,
    style: {
      fill: "#F99746"
    },
    width: 23.035,
    height: 2.912
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 614.453,
    y: 724.021,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.035,
    height: 2.912
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 724.021,
    style: {
      fill: "#FFFFFF"
    },
    width: 33.196,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.95,
    y: 724.021,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.269,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 732.433,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.451,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.35,
    y: 732.433,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.138,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.198,
    y: 732.433,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.035,
    height: 2.912
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 614.453,
    y: 639.63,
    style: {
      fill: "#F99746"
    },
    width: 23.035,
    height: 2.912
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 639.63,
    style: {
      fill: "#F99746"
    },
    width: 33.196,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.95,
    y: 639.63,
    style: {
      fill: "#F99746"
    },
    width: 29.269,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 648.042,
    style: {
      fill: "#F99746"
    },
    width: 38.451,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.35,
    y: 648.042,
    style: {
      fill: "#F99746"
    },
    width: 18.138,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.198,
    y: 648.042,
    style: {
      fill: "#F99746"
    },
    width: 23.035,
    height: 2.912
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 614.453,
    y: 667.761,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.035,
    height: 2.912
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 667.761,
    style: {
      fill: "#FFFFFF"
    },
    width: 33.196,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.95,
    y: 667.761,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.269,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 676.173,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.451,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.35,
    y: 676.173,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.138,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.198,
    y: 676.173,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.035,
    height: 2.912
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 614.453,
    y: 752.151,
    style: {
      fill: "#F99746"
    },
    width: 23.035,
    height: 2.912
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 752.151,
    style: {
      fill: "#F99746"
    },
    width: 33.196,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.95,
    y: 752.151,
    style: {
      fill: "#F99746"
    },
    width: 29.269,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.622,
    y: 760.563,
    style: {
      fill: "#F99746"
    },
    width: 38.451,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.35,
    y: 760.563,
    style: {
      fill: "#F99746"
    },
    width: 18.138,
    height: 2.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.198,
    y: 760.563,
    style: {
      fill: "#F99746"
    },
    width: 23.035,
    height: 2.912
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 254.829,
    y: 622.244,
    style: {
      fill: "#FFFFFF"
    },
    width: 120.119,
    height: 4.887
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.829,
    y: 635.837,
    style: {
      fill: "#FFFFFF"
    },
    width: 65.942,
    height: 4.887
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.039,
    y: 635.837,
    style: {
      fill: "#FFFFFF"
    },
    width: 65.942,
    height: 4.887
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.446,
    y: 622.244,
    style: {
      fill: "#FFFFFF"
    },
    width: 53.115,
    height: 4.241
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.123,
    y: 622.244,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.704,
    height: 4.241
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 708.409,
    y: 679.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 98.878,
    height: 4.023
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.409,
    y: 691.055,
    style: {
      fill: "#FFFFFF"
    },
    width: 54.282,
    height: 4.023
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770.319,
    y: 691.055,
    style: {
      fill: "#FFFFFF"
    },
    width: 54.281,
    height: 4.023
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.275,
    y: 679.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.723,
    height: 3.491
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.4,
    y: 679.864,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.037,
    height: 3.491
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2322.803,1229.875c0,0-32.198,33.384-33.72,45.949c-1.521,12.564,15.423,32.18,15.423,32.18 L2322.803,1229.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2337.352,1575.854c0,0,1.136,17.708,4.563,17.954c0.456,0.033,17.379-0.004,17.379-0.004 l21.602-0.172c0,0-0.152-5.205-6.47-6.292c-6.316-1.087-16.896-5.501-20.738-13.839 C2349.644,1564.729,2337.352,1575.854,2337.352,1575.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2289.235,1575.958c0,0,1.137,17.708,4.563,17.954c0.456,0.033,17.379-0.004,17.379-0.004 l21.602-0.172c0,0-0.152-5.205-6.47-6.292c-6.316-1.087-16.896-5.501-20.738-13.839 C2301.527,1564.834,2289.235,1575.958,2289.235,1575.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2360.861,1385.467c0,0-5.57,36.146-26.508,100.338c-20.938,64.19-23.749,91.974-23.749,91.974 l-22.611-0.585c0,0-0.346-70.103,9.298-102.38s1.844-116.291,1.844-116.291L2360.861,1385.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C468A"
    },
    d: "M2371.81,1360.344c0,0,0.919,54.451-8.357,121.33s-6.021,95.252-6.021,95.252l-22.563,0.8 c0,0-13.63-66.854-9.837-100.327c3.794-33.473-18.715-114.79-18.715-114.79L2371.81,1360.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2327.852,1233.012l12.039,7.856l17.368-3.275c-0.243-1.402-1.403-7.213-2.459-12.477 c-0.063-0.311-0.128-0.62-0.188-0.924c-0.904-4.479-1.686-8.326-1.686-8.326l-16.243-7.124l-6.057-2.656 c0.016,0.094,0.479,4.971,0.545,5.683C2332.334,1224.411,2327.852,1233.012,2327.852,1233.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2352.79,1228.98c-0.338-0.141-20.937-6.171-23.172-5.428c-2.234,0.743-3.549,5.073-3.549,5.073 l33.688,7.539C2359.758,1236.165,2357.096,1230.782,2352.79,1228.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F5099"
    },
    d: "M2297.656,1367.228c3.523,15.911,61.602,17.672,76.54,3.19c1.698-1.65,1.766-9.313,1.102-19.645 c-1.3-20.184-5.399-50.539-5.591-66.053c-0.093-7.491-1.139-15.151-2.525-22.106c-2.949-14.823-7.424-26.451-7.424-26.451 s-28.385-9.108-33.688-7.537C2300.516,1236.194,2294.132,1351.316,2297.656,1367.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2375.619,1350.672c-1.442-20.174-5.757-50.5-6.057-66.012c-0.146-7.49-1.246-15.143-2.682-22.088 l-17.09-2.854C2349.791,1259.719,2333.738,1328.01,2375.619,1350.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2365.996,1322.657c0,0-1.156,2.782,1.29,4.644s4.037,4.883,3.482,7.094s-5.904,5.828-7.763,5.251 c-1.858-0.578-5.646-3.48-5.24-4.646c0.404-1.167-2.565-10.225,1.955-13.724 C2364.241,1317.775,2365.996,1322.657,2365.996,1322.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F5099"
    },
    d: "M2346.72,1232.107c0,0,16.648,3.078,29.95,22.59s22.057,34.021,19.63,41.068 c-2.428,7.048-24.64,31.521-28.478,31.53c-3.838,0.008-10.038-2.77-10.401-9.05c0,0,15.625-23.528,12.529-27.04 c-1.323-1.501-20.388-16.909-23.09-9.925C2342.391,1292.838,2346.72,1232.107,2346.72,1232.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA56B"
    },
    d: "M2332.39,1211.989c3.577,6.028,16.868,11.22,22.41,13.127c-0.063-0.311-0.128-0.62-0.188-0.924 c-0.904-4.479-1.686-8.326-1.686-8.326l-16.243-7.124C2333.096,1208.7,2330.914,1209.508,2332.39,1211.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2359.042,1214.866c0,0-26.123,8.212-30.986-8.135s-11.51-26.296,4.964-32.23 c16.473-5.934,21.584-0.664,24.534,4.397C2360.504,1183.959,2365.712,1212.31,2359.042,1214.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2356.523,1177.324c0,0-1.626,19.038-5.563,18.221c-3.938-0.818-7.51-1.423-6.921,4.313 s6.062,12.351-6.067,13.392c-12.13,1.041-29.637-30.207-26.317-36.138C2321.233,1160,2370.377,1156.443,2356.523,1177.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M974.347,1244.575c0,0,30.159,31.27,31.584,43.039s-14.446,30.142-14.446,30.142L974.347,1244.575z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M960.719,1568.646c0,0-1.064,16.586-4.274,16.817c-0.427,0.03-16.278-0.004-16.278-0.004 l-20.234-0.162c0,0,0.143-4.875,6.06-5.893c5.917-1.018,15.826-5.153,19.426-12.963 C949.206,1558.227,960.719,1568.646,960.719,1568.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1005.788,1568.743c0,0-1.065,16.586-4.274,16.817c-0.427,0.03-16.278-0.004-16.278-0.004 l-20.234-0.161c0,0,0.143-4.875,6.06-5.894c5.917-1.018,15.825-5.152,19.425-12.963 C994.274,1558.324,1005.788,1568.743,1005.788,1568.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M938.697,1390.314c0,0,5.218,33.857,24.83,93.984c19.611,60.126,22.245,86.149,22.245,86.149 l21.18-0.548c0,0,0.323-65.663-8.71-95.896c-9.032-30.233-1.727-108.928-1.727-108.928L938.697,1390.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C468A"
    },
    d: "M928.442,1366.782c0,0-0.86,51.003,7.829,113.647c8.688,62.644,5.639,89.221,5.639,89.221 l21.135,0.748c0,0,12.767-62.62,9.213-93.974c-3.553-31.353,17.53-107.521,17.53-107.521L928.442,1366.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M969.617,1247.514l-11.277,7.359l-16.268-3.068c0.228-1.313,1.314-6.757,2.304-11.687 c0.06-0.291,0.12-0.582,0.175-0.866c0.847-4.194,1.579-7.798,1.579-7.798l15.215-6.674l5.673-2.488 c-0.015,0.088-0.45,4.657-0.51,5.323C965.419,1239.458,969.617,1247.514,969.617,1247.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M946.258,1243.737c0.316-0.132,19.611-5.78,21.704-5.084c2.093,0.696,3.325,4.752,3.325,4.752 l-31.555,7.062C939.731,1250.467,942.225,1245.425,946.258,1243.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M997.9,1373.229c-3.301,14.903-57.701,16.554-71.693,2.989c-1.592-1.547-1.654-8.725-1.032-18.4 c1.218-18.905,5.058-47.339,5.237-61.87c0.087-7.017,1.067-14.192,2.365-20.707c2.763-13.885,6.954-24.775,6.954-24.775 s26.587-8.532,31.556-7.061C995.222,1250.494,1001.201,1358.326,997.9,1373.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M925.175,1357.818c1.218-18.905,5.058-47.339,5.237-61.87c0.087-7.017,1.067-14.192,2.365-20.707 l15.989-2.786C948.766,1272.455,964.254,1336.315,925.175,1357.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M933.888,1331.482c0,0,1.083,2.606-1.208,4.35s-3.782,4.573-3.262,6.645 c0.52,2.07,5.531,5.459,7.272,4.918c1.741-0.541,5.288-3.26,4.909-4.353c-0.379-1.093,2.402-9.577-1.832-12.854 C935.532,1326.91,933.888,1331.482,933.888,1331.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M951.943,1246.666c0,0-15.593,2.884-28.053,21.16c-12.459,18.275-20.66,31.865-18.387,38.467 c2.273,6.602,23.079,29.526,26.674,29.534c3.595,0.008,9.403-2.595,9.743-8.477c0,0-14.635-22.038-11.735-25.328 c1.239-1.405,19.097-15.839,21.627-9.296C955.999,1303.551,951.943,1246.666,951.943,1246.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA56B"
    },
    d: "M965.366,1227.822c-3.35,5.646-15.799,10.51-20.991,12.296c0.06-0.291,0.12-0.582,0.175-0.866 c0.847-4.194,1.579-7.798,1.579-7.798l15.215-6.674C964.705,1224.742,966.748,1225.498,965.366,1227.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M940.402,1230.518c0,0,24.469,7.69,29.024-7.621c4.555-15.312,10.781-24.631-4.649-30.188 c-15.43-5.558-20.217-0.623-22.981,4.118S934.154,1228.122,940.402,1230.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M942.761,1195.353c0,0,1.523,17.832,5.212,17.066c3.689-0.767,7.034-1.333,6.483,4.04 c-0.552,5.374-5.678,11.568,5.683,12.544c11.361,0.976,27.76-28.294,24.65-33.85 C975.816,1179.125,929.785,1175.794,942.761,1195.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M864.488,1568.232c-1.003,0-1.861-0.705-2.033-1.667l-9.964-56.478l-14.332-81.227l-4.008-22.713 l10.208-0.292l1.771,13.186l12.436,92.659l7.373,54.924C866.053,1567.477,865.373,1568.232,864.488,1568.232z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M846.131,1419.042c-6.613,2.919-7.972,9.819-7.972,9.819l-4.008-22.713l10.208-0.292 L846.131,1419.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M346.81,1568.232c1.003,0,1.861-0.705,2.033-1.667l9.964-56.478l14.332-81.227l4.008-22.713 l-10.208-0.292l-1.772,13.186l-12.436,92.659l-7.373,54.924C345.245,1567.477,345.926,1568.232,346.81,1568.232z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M365.167,1419.042c6.614,2.919,7.972,9.819,7.972,9.819l4.008-22.713l-10.208-0.292 L365.167,1419.042z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M868.417,1415.065H325.193c-4.902,0-8.912-4.011-8.912-8.912v-0.011 c0-4.902,4.01-8.912,8.912-8.912h543.224c4.902,0,8.912,4.01,8.912,8.912v0.011 C877.329,1411.055,873.318,1415.065,868.417,1415.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1891.735,1568.232c-1.003,0-1.861-0.705-2.033-1.667l-9.964-56.478l-14.332-81.227 l-4.008-22.713l10.208-0.292l1.772,13.186l12.437,92.659l7.372,54.924C1893.3,1567.477,1892.619,1568.232,1891.735,1568.232z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1873.378,1419.042c-6.613,2.919-7.972,9.819-7.972,9.819l-4.008-22.713l10.208-0.292 L1873.378,1419.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1374.057,1568.232c1.003,0,1.861-0.705,2.033-1.667l9.964-56.478l14.333-81.227l4.007-22.713 l-10.208-0.292l-1.771,13.186l-12.436,92.659l-7.373,54.924C1372.492,1567.477,1373.173,1568.232,1374.057,1568.232z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1392.415,1419.042c6.613,2.919,7.972,9.819,7.972,9.819l4.007-22.713l-10.208-0.292 L1392.415,1419.042z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1895.664,1415.065H1352.44c-4.902,0-8.912-4.011-8.912-8.912v-0.011 c0-4.902,4.01-8.912,8.912-8.912h543.224c4.901,0,8.912,4.01,8.912,8.912v0.011 C1904.576,1411.055,1900.565,1415.065,1895.664,1415.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1125.888,
    y: 467.279,
    style: {
      fill: "#1C468A"
    },
    width: 884.993,
    height: 447.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1135.381,
    y: 479.452,
    style: {
      fill: "#AEC3FF"
    },
    width: 866.006,
    height: 422.938
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1228.993,
    y: 309.369,
    style: {
      fill: "#1C468A"
    },
    width: 12.399,
    height: 157.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1895.377,
    y: 309.369,
    style: {
      fill: "#1C468A"
    },
    width: 12.399,
    height: 157.91
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1969.298,798.257h-416.841V506.068h416.841V798.257z M1555.399,795.315h410.956V509.01h-410.956 V795.315z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1938.654,758.193h-369.689c0,0,59.405-42.728,77.722-40.49 c18.316,2.238,46.663,19.532,63.386,20.203s25.968-59.97,44.886-57.112c18.917,2.857,33.63,56.492,42.457,51.253 c8.827-5.24,37.271-7.511,54.926,0c17.655,7.511,37.271-23.875,51.984-22.894 C1919.037,710.133,1938.654,758.193,1938.654,758.193z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1574.85,
    y: 667.792,
    style: {
      fill: "#F99746"
    },
    width: 70.609,
    height: 4.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1574.85,
    y: 677.509,
    style: {
      fill: "#F99746"
    },
    width: 70.609,
    height: 4.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1568.965,611.731h369.689c0,0-59.405-42.728-77.723-40.49 c-18.316,2.238-46.663,19.532-63.386,20.203s-25.968-59.97-44.885-57.113c-18.917,2.857-33.63,56.493-42.457,51.253 c-8.828-5.24-37.271-7.511-54.927,0c-17.654,7.511-37.271-23.875-51.983-22.894 C1588.581,563.67,1568.965,611.731,1568.965,611.731z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1574.85,
    y: 529.683,
    style: {
      fill: "#FFFFFF"
    },
    width: 70.609,
    height: 4.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1574.85,
    y: 539.399,
    style: {
      fill: "#FFFFFF"
    },
    width: 70.609,
    height: 4.55
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1555.966,
    y: 818.369,
    style: {
      fill: "#FFFFFF"
    },
    width: 149.092,
    height: 5.576
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1555.966,
    y: 837.961,
    style: {
      fill: "#FFFFFF"
    },
    width: 101.623,
    height: 5.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1555.966,
    y: 857.552,
    style: {
      fill: "#FFFFFF"
    },
    width: 114.817,
    height: 5.576
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1689.107,
    y: 857.552,
    style: {
      fill: "#FFFFFF"
    },
    width: 101.623,
    height: 5.576
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.414,
    y: 837.961,
    style: {
      fill: "#FFFFFF"
    },
    width: 101.623,
    height: 5.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1793.762,
    y: 837.961,
    style: {
      fill: "#FFFFFF"
    },
    width: 64.283,
    height: 5.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1723.093,
    y: 818.369,
    style: {
      fill: "#FFFFFF"
    },
    width: 100.624,
    height: 5.576
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1838.03,
    y: 818.369,
    style: {
      fill: "#FFFFFF"
    },
    width: 75.647,
    height: 5.576
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1174.561,
    y: 790.995,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 78.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.306,
    y: 808.875,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 60.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1228.051,
    y: 795.202,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 74.323
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254.796,
    y: 777.523,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.633,
    height: 92.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1281.542,
    y: 808.875,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 60.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1308.287,
    y: 822.49,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 47.035
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1366.314,
    y: 777.523,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 92.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1393.059,
    y: 798.257,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.633,
    height: 71.268
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1419.805,
    y: 795.202,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 74.323
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1446.55,
    y: 812.99,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 56.535
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1473.295,
    y: 808.875,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 60.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500.04,
    y: 822.49,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.632,
    height: 47.035
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1170.694,
    y: 506.068,
    style: {
      fill: "#FFFFFF"
    },
    width: 76.988,
    height: 7.212
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.694,
    y: 525.659,
    style: {
      fill: "#FFFFFF"
    },
    width: 60.545,
    height: 7.212
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1243.263,
    y: 525.659,
    style: {
      fill: "#FFFFFF"
    },
    width: 81.771,
    height: 7.212
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1333.62,
    y: 525.659,
    style: {
      fill: "#FFFFFF"
    },
    width: 50.181,
    height: 7.212
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1263.29,
    y: 506.068,
    style: {
      fill: "#FFFFFF"
    },
    width: 58.916,
    height: 7.212
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1333.159,
    y: 506.068,
    style: {
      fill: "#FFFFFF"
    },
    width: 82.693,
    height: 7.212
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.22,
    y: 571.748,
    style: {
      fill: "#1C468A"
    },
    width: 122.054,
    height: 79.965
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1216.148,
    y: 579.844,
    style: {
      fill: "#F99746"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1177.517,
    y: 579.844,
    style: {
      fill: "#F99746"
    },
    width: 32.197,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1243.788,
    y: 579.844,
    style: {
      fill: "#F99746"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1177.517,
    y: 587.641,
    style: {
      fill: "#F99746"
    },
    width: 37.293,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.898,
    y: 587.641,
    style: {
      fill: "#F99746"
    },
    width: 17.592,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.088,
    y: 587.641,
    style: {
      fill: "#F99746"
    },
    width: 22.342,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1216.148,
    y: 603.984,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1177.517,
    y: 603.984,
    style: {
      fill: "#FFFFFF"
    },
    width: 32.197,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1243.788,
    y: 603.984,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1177.517,
    y: 611.78,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.293,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.898,
    y: 611.78,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.592,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.088,
    y: 611.78,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1216.148,
    y: 629.023,
    style: {
      fill: "#F99746"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1177.517,
    y: 629.023,
    style: {
      fill: "#F99746"
    },
    width: 32.197,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1243.788,
    y: 629.023,
    style: {
      fill: "#F99746"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1177.517,
    y: 636.819,
    style: {
      fill: "#F99746"
    },
    width: 37.293,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220.898,
    y: 636.819,
    style: {
      fill: "#F99746"
    },
    width: 17.592,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.088,
    y: 636.819,
    style: {
      fill: "#F99746"
    },
    width: 22.342,
    height: 2.699
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1323.3,
    y: 571.748,
    style: {
      fill: "#1C468A"
    },
    width: 122.054,
    height: 79.965
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1369.901,
    y: 579.844,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1331.27,
    y: 579.844,
    style: {
      fill: "#FFFFFF"
    },
    width: 32.197,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1397.541,
    y: 579.844,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1331.27,
    y: 587.641,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.294,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1374.65,
    y: 587.641,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.592,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.841,
    y: 587.641,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1369.901,
    y: 603.984,
    style: {
      fill: "#F99746"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1331.27,
    y: 603.984,
    style: {
      fill: "#F99746"
    },
    width: 32.197,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1397.541,
    y: 603.984,
    style: {
      fill: "#F99746"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1331.27,
    y: 611.78,
    style: {
      fill: "#F99746"
    },
    width: 37.294,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1374.65,
    y: 611.78,
    style: {
      fill: "#F99746"
    },
    width: 17.592,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.841,
    y: 611.78,
    style: {
      fill: "#F99746"
    },
    width: 22.342,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1369.901,
    y: 629.023,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1331.27,
    y: 629.023,
    style: {
      fill: "#FFFFFF"
    },
    width: 32.197,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1397.541,
    y: 629.023,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1331.27,
    y: 636.819,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.294,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1374.65,
    y: 636.819,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.592,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.841,
    y: 636.819,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 681.966,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.888,
    y: 681.966,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1234.257,
    y: 681.966,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1256.557,
    y: 681.966,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 697.901,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.888,
    y: 697.901,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1234.257,
    y: 697.901,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1256.557,
    y: 697.901,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 673.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.096,
    y: 673.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1244.61,
    y: 673.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 690.195,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.096,
    y: 690.195,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1244.61,
    y: 690.195,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 713.837,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.888,
    y: 713.837,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1234.257,
    y: 713.837,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1256.557,
    y: 713.837,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 706.13,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.096,
    y: 706.13,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1244.61,
    y: 706.13,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 728.776,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.888,
    y: 728.776,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1234.257,
    y: 728.776,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1256.557,
    y: 728.776,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1171.282,
    y: 721.07,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.096,
    y: 721.07,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1244.61,
    y: 721.07,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.63,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360.999,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1383.299,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.63,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360.999,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1383.299,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 672.262,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1343.838,
    y: 672.262,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.352,
    y: 672.262,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 689.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1343.838,
    y: 689.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.352,
    y: 689.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.63,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360.999,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1383.299,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 705.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1343.838,
    y: 705.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.352,
    y: 705.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.63,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360.999,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1383.299,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.024,
    y: 720.081,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1343.838,
    y: 720.081,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1371.352,
    y: 720.081,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.775,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1482.144,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1504.444,
    y: 680.977,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.775,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1482.144,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1504.444,
    y: 696.913,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 672.262,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1464.983,
    y: 672.262,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.497,
    y: 672.262,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 689.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1464.983,
    y: 689.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.497,
    y: 689.206,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.775,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1482.144,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1504.444,
    y: 712.848,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 705.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1464.983,
    y: 705.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.497,
    y: 705.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.265,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1449.775,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 30.104,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1482.144,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.192,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1504.444,
    y: 727.787,
    style: {
      fill: "#FFFFFF"
    },
    width: 14.811,
    height: 3.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1419.169,
    y: 720.081,
    style: {
      fill: "#FFFFFF"
    },
    width: 41.831,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1464.983,
    y: 720.081,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.112,
    height: 3.735
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.497,
    y: 720.081,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.777,
    height: 3.735
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 427.003,
    y: 587.457,
    style: {
      fill: "#F99746"
    },
    width: 119.67,
    height: 30.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.003,
    y: 537.264,
    style: {
      fill: "#F99746"
    },
    width: 119.67,
    height: 30.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.003,
    y: 487.071,
    style: {
      fill: "#F99746"
    },
    width: 119.67,
    height: 30.875
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2146.625,
    y: 442.18,
    style: {
      fill: "#1C468A"
    },
    width: 744.327,
    height: 376.189
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2154.609,
    y: 452.418,
    style: {
      fill: "#AEC3FF"
    },
    width: 728.358,
    height: 355.714
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2233.342,
    y: 309.369,
    style: {
      fill: "#1C468A"
    },
    width: 10.428,
    height: 132.811
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2793.808,
    y: 309.369,
    style: {
      fill: "#1C468A"
    },
    width: 10.428,
    height: 132.811
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2606.518,775.117h-416.841V482.928h416.841V775.117z M2192.619,772.175h410.956V485.871 h-410.956V772.175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2575.874,735.054h-369.689c0,0,59.405-42.728,77.722-40.49 c18.317,2.238,46.664,19.532,63.387,20.203c16.723,0.671,25.967-59.969,44.885-57.112c18.917,2.857,33.63,56.493,42.457,51.253 c8.828-5.239,37.271-7.511,54.927,0c17.655,7.511,37.271-23.875,51.983-22.894 C2556.258,686.993,2575.874,735.054,2575.874,735.054z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2212.069,
    y: 644.653,
    style: {
      fill: "#F99746"
    },
    width: 70.61,
    height: 4.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2212.069,
    y: 654.37,
    style: {
      fill: "#F99746"
    },
    width: 70.61,
    height: 4.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2206.185,588.591h369.689c0,0-59.405-42.728-77.722-40.49s-46.663,19.532-63.387,20.203 c-16.723,0.671-25.967-59.97-44.885-57.113c-18.917,2.858-33.63,56.493-42.457,51.253c-8.827-5.24-37.271-7.511-54.926,0 c-17.655,7.511-37.271-23.875-51.984-22.894C2225.801,540.53,2206.185,588.591,2206.185,588.591z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2212.069,
    y: 506.543,
    style: {
      fill: "#FFFFFF"
    },
    width: 70.61,
    height: 4.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2212.069,
    y: 516.26,
    style: {
      fill: "#FFFFFF"
    },
    width: 70.61,
    height: 4.55
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.676,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2655.158,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.661,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2689.201,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.185,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2712.655,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.578,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.676,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2655.158,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.661,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2689.201,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.185,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2712.655,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.578,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 632.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2671.153,
    y: 632.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.359,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.09,
    y: 632.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 649.969,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2671.153,
    y: 649.969,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.359,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.09,
    y: 649.969,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.676,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2655.158,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.661,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2689.201,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.185,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2712.655,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.578,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 666.729,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2671.153,
    y: 666.729,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.359,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.09,
    y: 666.729,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.676,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2655.158,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.661,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2689.201,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.185,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2712.655,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.578,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 682.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2671.153,
    y: 682.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.359,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.09,
    y: 682.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.675,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2782.571,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.662,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2816.615,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.186,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2840.069,
    y: 641.314,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.577,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.675,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2782.571,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.662,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2816.615,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.186,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2840.069,
    y: 658.074,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.577,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 632.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2798.566,
    y: 632.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.36,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2827.504,
    y: 632.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 649.969,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2798.566,
    y: 649.969,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.36,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2827.504,
    y: 649.969,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.675,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2782.571,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.662,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2816.615,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.186,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2840.069,
    y: 674.834,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.577,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 666.729,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2798.566,
    y: 666.729,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.36,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2827.504,
    y: 666.729,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.675,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2782.571,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.662,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2816.615,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.186,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2840.069,
    y: 690.546,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.577,
    height: 3.928
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2750.382,
    y: 682.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.995,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2798.566,
    y: 682.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 25.36,
    height: 3.928
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2827.504,
    y: 682.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.163,
    height: 3.928
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 2622.968,
    y: 485.871,
    style: {
      fill: "#1C468A"
    },
    width: 232.699,
    height: 113.771
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2674.395,
    y: 496.487,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 496.487,
    style: {
      fill: "#FFFFFF"
    },
    width: 32.196,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2702.033,
    y: 496.487,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 504.284,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.293,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2679.144,
    y: 504.284,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.593,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.334,
    y: 504.284,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.343,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2674.395,
    y: 522.076,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 522.076,
    style: {
      fill: "#FFFFFF"
    },
    width: 32.196,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2702.033,
    y: 522.076,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 529.873,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.293,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2679.144,
    y: 529.873,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.593,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.334,
    y: 529.873,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.343,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2674.395,
    y: 547.665,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 547.665,
    style: {
      fill: "#FFFFFF"
    },
    width: 32.196,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2702.033,
    y: 547.665,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 555.462,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.293,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2679.144,
    y: 555.462,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.593,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.334,
    y: 555.462,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.343,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2674.395,
    y: 575.353,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.342,
    height: 2.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 575.353,
    style: {
      fill: "#FFFFFF"
    },
    width: 32.196,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2702.033,
    y: 575.353,
    style: {
      fill: "#FFFFFF"
    },
    width: 28.388,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2635.763,
    y: 583.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.293,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2679.144,
    y: 583.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.593,
    height: 2.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2700.334,
    y: 583.15,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.343,
    height: 2.699
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2622.968,772.175h232.699c0,0-37.393-26.895-48.922-25.486 c-11.529,1.409-29.372,12.294-39.897,12.716c-10.526,0.422-16.346-37.748-28.253-35.949 c-11.907,1.798-21.168,35.559-26.725,32.261c-5.557-3.298-23.46-4.728-34.573,0c-11.112,4.727-23.46-15.028-32.721-14.411 C2635.315,741.923,2622.968,772.175,2622.968,772.175z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2626.672,
    y: 720.53,
    style: {
      fill: "#FFFFFF"
    },
    width: 44.445,
    height: 2.864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2626.672,
    y: 726.646,
    style: {
      fill: "#FFFFFF"
    },
    width: 44.445,
    height: 2.864
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M649.73,1390.059c0,0,15.858-3.688,19.915,0c4.057,3.688,5.347,9.035,5.347,9.035H649.73V1390.059z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M478.814,1330.258c0,0-22.701,18.495-27.127,45.786c-4.425,27.291,49.803,22.865,49.803,22.865 L478.814,1330.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M549.184,1568.16c0,0,1.018,15.868,4.089,16.089c0.409,0.029,15.573-0.003,15.573-0.003 l19.359-0.154c0,0-0.137-4.665-5.798-5.639c-5.661-0.974-15.141-4.93-18.585-12.401 C560.199,1558.191,549.184,1568.16,549.184,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M583.113,1568.16c0,0,1.018,15.868,4.089,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.797-5.639c-5.661-0.974-15.141-4.93-18.585-12.401 C594.128,1558.191,583.113,1568.16,583.113,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M475.556,1437.633c-0.876,0.737-10.814,28.396-10.229,46.837h75.993c0,0,24.506,4.379,25.091,9.675 c0.584,5.296,5.599,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.677-6.393-52.853-25.398-68.452-27.291 C505.787,1437.953,475.556,1437.633,475.556,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M459.063,1437.633c-0.877,0.737-11.064,30.609,1.844,46.837h47.501c0,0,24.506,4.379,25.091,9.675 c0.584,5.296,5.599,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.676-6.393-52.852-25.398-68.452-27.291 C472.876,1437.953,459.063,1437.633,459.063,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M506.443,1325.491l11.396,7.472l16.471-3.069c-0.228-1.33-1.315-6.841-2.305-11.832 c-0.06-0.294-0.12-0.589-0.176-0.876c-0.848-4.248-1.581-7.896-1.581-7.896l-15.384-6.787l-5.736-2.53 c0.015,0.089,0.445,4.714,0.504,5.388C510.71,1317.348,506.443,1325.491,506.443,1325.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M536.048,1308.354c0,0-24.78,7.73-29.357-7.775s-10.856-24.951,4.771-30.542 c15.628-5.592,20.462-0.586,23.249,4.218C537.498,1279.059,542.376,1305.943,536.048,1308.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5453C"
    },
    d: "M533.738,1272.761c0,0-1.581,18.044-5.312,17.26c-3.731-0.783-7.116-1.363-6.569,4.075 c0.546,5.439,5.721,11.721-5.779,12.683c-11.5,0.962-28.032-28.696-24.873-34.312 C500.32,1256.265,546.913,1252.995,533.738,1272.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M530.093,1321.721c-0.32-0.135-18.447-8.267-20.567-7.566c-2.12,0.7-4.762,7.175-4.762,7.175 l31.919,7.217C536.683,1328.546,534.17,1323.438,530.093,1321.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M558.281,1345.751c0,0-10.067-14.599-21.599-17.205c-11.531-2.607-31.919-7.217-31.919-7.217 s-26.48,5.595-29.185,12.211c-2.705,6.616-27.3,117.384-19.958,127.818s76.683,9.52,86.544,2.673 c9.86-6.847,11.479-52.059,13.218-78.402C557.122,1359.286,558.281,1345.751,558.281,1345.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M516.167,1470.777h-57.484c-9.979,0-18.144-8.164-18.144-18.145v-85.078 c0-9.979,8.165-18.145,18.144-18.145h57.484c9.979,0,18.144,8.165,18.144,18.145v85.078 C534.311,1462.613,526.146,1470.777,516.167,1470.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M567.625,1512.498H451.612c-4.066,0-7.393-3.327-7.393-7.394v-13.242 c0-4.065,3.327-7.393,7.393-7.393h116.013c4.066,0,7.394,3.327,7.394,7.393v13.242 C575.019,1509.171,571.691,1512.498,567.625,1512.498z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.399,
    y: 1512.498,
    style: {
      fill: "#2B478B"
    },
    width: 8.44,
    height: 69.333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M536.683,1328.546c0,0,17.99,1.952,28.136,18.732c6.275,10.377,24.245,34.113,36.046,34.851 c11.801,0.737,48.865,7.93,48.865,7.93v9.116l-56.506,1.55c-0.692,0.02-1.376-0.034-2.057-0.162 c-6.039-1.14-36.729-7.252-41.381-14.562C544.623,1377.888,536.683,1328.546,536.683,1328.546z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.453,
    y: 1577.406,
    style: {
      fill: "#2B478B"
    },
    width: 58.27,
    height: 4.425
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M479.347,1586.994c0-2.852,2.311-5.163,5.163-5.163c2.852,0,5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163C481.658,1592.157,479.347,1589.846,479.347,1586.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M527.167,1586.994c0-2.852,2.312-5.163,5.163-5.163c2.852,0,5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163C529.479,1592.157,527.167,1589.846,527.167,1586.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M839.076,1390.059c0,0,15.858-3.688,19.914,0c4.057,3.688,5.348,9.035,5.348,9.035h-25.262 V1390.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M668.159,1330.258c0,0-22.701,18.495-27.126,45.786c-4.426,27.291,49.803,22.865,49.803,22.865 L668.159,1330.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M738.529,1568.16c0,0,1.018,15.868,4.089,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.798-5.639c-5.661-0.974-15.141-4.93-18.585-12.401 C749.544,1558.191,738.529,1568.16,738.529,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M772.458,1568.16c0,0,1.019,15.868,4.09,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.798-5.639c-5.661-0.974-15.141-4.93-18.585-12.401 C783.474,1558.191,772.458,1568.16,772.458,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M664.901,1437.633c-0.877,0.737-10.815,28.396-10.23,46.837h75.994c0,0,24.506,4.379,25.09,9.675 c0.584,5.296,5.599,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.676-6.393-52.852-25.398-68.452-27.291 C695.132,1437.953,664.901,1437.633,664.901,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M648.409,1437.633c-0.877,0.737-11.064,30.609,1.844,46.837h47.502c0,0,24.506,4.379,25.091,9.675 c0.584,5.296,5.599,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.677-6.393-52.853-25.398-68.452-27.291 C662.221,1437.953,648.409,1437.633,648.409,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M695.789,1325.491l11.396,7.472l16.471-3.069c-0.228-1.33-1.315-6.841-2.306-11.832 c-0.06-0.294-0.12-0.589-0.176-0.876c-0.848-4.248-1.581-7.896-1.581-7.896l-15.383-6.787l-5.736-2.53 c0.015,0.089,0.445,4.714,0.504,5.388C700.056,1317.348,695.789,1325.491,695.789,1325.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M725.394,1308.354c0,0-24.78,7.73-29.357-7.775c-4.577-15.506-10.857-24.951,4.771-30.542 c15.628-5.592,20.462-0.586,23.248,4.218C726.843,1279.059,731.722,1305.943,725.394,1308.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M723.083,1272.761c0,0-1.58,18.044-5.312,17.26c-3.731-0.783-7.116-1.363-6.57,4.075 c0.546,5.439,5.721,11.721-5.779,12.683c-11.5,0.962-28.032-28.696-24.873-34.312 C689.666,1256.265,736.259,1252.995,723.083,1272.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M719.438,1321.721c-0.32-0.135-18.447-8.267-20.567-7.566s-4.763,7.175-4.763,7.175l31.92,7.217 C726.028,1328.546,723.516,1323.438,719.438,1321.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M747.627,1345.751c0,0-10.068-14.599-21.599-17.205c-11.531-2.607-31.92-7.217-31.92-7.217 s-26.479,5.595-29.184,12.211c-2.706,6.616-27.301,117.384-19.958,127.818c7.343,10.435,76.684,9.52,86.544,2.673 c9.861-6.847,11.479-52.059,13.218-78.402C746.467,1359.286,747.627,1345.751,747.627,1345.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M705.512,1470.777h-57.484c-9.979,0-18.145-8.164-18.145-18.145v-85.078 c0-9.979,8.165-18.145,18.145-18.145h57.484c9.979,0,18.144,8.165,18.144,18.145v85.078 C723.657,1462.613,715.492,1470.777,705.512,1470.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M756.971,1512.498H640.958c-4.066,0-7.393-3.327-7.393-7.394v-13.242 c0-4.065,3.327-7.393,7.393-7.393h116.013c4.066,0,7.393,3.327,7.393,7.393v13.242 C764.364,1509.171,761.037,1512.498,756.971,1512.498z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.744,
    y: 1512.498,
    style: {
      fill: "#2B478B"
    },
    width: 8.44,
    height: 69.333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M726.028,1328.546c0,0,17.99,1.952,28.136,18.732c6.274,10.377,24.244,34.113,36.045,34.851 c11.802,0.737,48.866,7.93,48.866,7.93v9.116l-56.506,1.55c-0.692,0.02-1.377-0.034-2.057-0.162 c-6.039-1.14-36.729-7.252-41.38-14.562C733.969,1377.888,726.028,1328.546,726.028,1328.546z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.799,
    y: 1577.406,
    style: {
      fill: "#2B478B"
    },
    width: 58.27,
    height: 4.425
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M668.692,1586.994c0-2.852,2.312-5.163,5.163-5.163c2.851,0,5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163C671.004,1592.157,668.692,1589.846,668.692,1586.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M716.513,1586.994c0-2.852,2.312-5.163,5.163-5.163c2.852,0,5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163C718.824,1592.157,716.513,1589.846,716.513,1586.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M3012.421,1570.096c-1.004,0-1.861-0.705-2.033-1.667l-9.964-56.478l-14.332-81.227 l-4.008-22.713l10.208-0.292l1.771,13.186l12.436,92.659l7.373,54.924C3013.985,1569.34,3013.305,1570.096,3012.421,1570.096z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2994.063,1420.905c-6.614,2.919-7.972,9.819-7.972,9.819l-4.008-22.713l10.208-0.292 L2994.063,1420.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2494.742,1570.096c1.004,0,1.861-0.705,2.033-1.667l9.964-56.478l14.332-81.227l4.008-22.713 l-10.208-0.292l-1.771,13.186l-12.436,92.659l-7.373,54.924C2493.178,1569.34,2493.858,1570.096,2494.742,1570.096z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2513.1,1420.905c6.613,2.919,7.972,9.819,7.972,9.819l4.008-22.713l-10.208-0.292 L2513.1,1420.905z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M3016.349,1416.929h-543.224c-4.901,0-8.912-4.011-8.912-8.912v-0.011 c0-4.901,4.011-8.912,8.912-8.912h543.224c4.902,0,8.912,4.011,8.912,8.912v0.011 C3025.261,1412.918,3021.251,1416.929,3016.349,1416.929z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2973.729,1390.059c0,0,15.858-3.688,19.915,0c4.057,3.688,5.348,9.035,5.348,9.035h-25.263 V1390.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2802.813,1330.258c0,0-22.701,18.495-27.127,45.786s49.803,22.865,49.803,22.865 L2802.813,1330.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2873.183,1568.16c0,0,1.019,15.868,4.09,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.798-5.639c-5.66-0.974-15.141-4.93-18.585-12.401 C2884.198,1558.191,2873.183,1568.16,2873.183,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2907.112,1568.16c0,0,1.019,15.868,4.089,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.797-5.639c-5.661-0.974-15.141-4.93-18.585-12.401 C2918.127,1558.191,2907.112,1568.16,2907.112,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2799.556,1437.633c-0.877,0.737-10.814,28.396-10.23,46.837h75.993c0,0,24.506,4.379,25.091,9.675 s5.6,33.843,15.537,74.41h15.783c0,0-3.216-95.026-7.892-101.418c-4.677-6.393-52.853-25.398-68.452-27.291 S2799.556,1437.633,2799.556,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2783.063,1437.633c-0.877,0.737-11.064,30.609,1.844,46.837h47.502c0,0,24.506,4.379,25.09,9.675 c0.585,5.296,5.6,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.677-6.393-52.853-25.398-68.452-27.291 S2783.063,1437.633,2783.063,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2830.442,1325.491l11.397,7.472l16.471-3.069c-0.229-1.33-1.315-6.841-2.306-11.832 c-0.06-0.294-0.119-0.589-0.176-0.876c-0.848-4.248-1.58-7.896-1.58-7.896l-15.384-6.787l-5.736-2.53 c0.016,0.089,0.445,4.714,0.505,5.388C2834.71,1317.348,2830.442,1325.491,2830.442,1325.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2860.047,1308.354c0,0-24.779,7.73-29.355-7.775c-4.577-15.506-10.857-24.951,4.771-30.542 c15.628-5.592,20.462-0.586,23.249,4.218C2861.497,1279.059,2866.375,1305.943,2860.047,1308.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2857.737,1272.761c0,0-1.58,18.044-5.312,17.26c-3.731-0.783-7.116-1.363-6.569,4.075 c0.546,5.439,5.721,11.721-5.779,12.683s-28.032-28.696-24.873-34.312C2824.319,1256.265,2870.912,1252.995,2857.737,1272.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2854.092,1321.721c-0.319-0.135-18.447-8.267-20.566-7.566c-2.12,0.7-4.763,7.175-4.763,7.175 l31.919,7.217C2860.682,1328.546,2858.17,1323.438,2854.092,1321.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2882.281,1345.751c0,0-10.068-14.599-21.6-17.205c-11.53-2.607-31.919-7.217-31.919-7.217 s-26.479,5.595-29.185,12.211s-27.301,117.384-19.958,127.818s76.684,9.52,86.544,2.673s11.479-52.059,13.218-78.402 C2881.121,1359.286,2882.281,1345.751,2882.281,1345.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2840.166,1470.777h-57.484c-9.979,0-18.144-8.164-18.144-18.145v-85.078 c0-9.979,8.165-18.145,18.144-18.145h57.484c9.979,0,18.145,8.165,18.145,18.145v85.078 C2858.311,1462.613,2850.146,1470.777,2840.166,1470.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2891.625,1512.498h-116.014c-4.066,0-7.393-3.327-7.393-7.394v-13.242 c0-4.065,3.326-7.393,7.393-7.393h116.014c4.065,0,7.393,3.327,7.393,7.393v13.242 C2899.018,1509.171,2895.69,1512.498,2891.625,1512.498z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2829.398,
    y: 1512.498,
    style: {
      fill: "#2B478B"
    },
    width: 8.439,
    height: 69.333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2860.682,1328.546c0,0,17.991,1.952,28.137,18.732c6.274,10.377,24.244,34.113,36.046,34.851 c11.801,0.737,48.865,7.93,48.865,7.93v9.116l-56.506,1.55c-0.692,0.02-1.377-0.034-2.058-0.162 c-6.038-1.14-36.729-7.252-41.38-14.562C2868.623,1377.888,2860.682,1328.546,2860.682,1328.546z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2804.452,
    y: 1577.406,
    style: {
      fill: "#2B478B"
    },
    width: 58.271,
    height: 4.425
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2803.346,1586.994c0-2.852,2.313-5.163,5.164-5.163c2.851,0,5.162,2.312,5.162,5.163 s-2.312,5.163-5.162,5.163C2805.658,1592.157,2803.346,1589.846,2803.346,1586.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2851.166,1586.994c0-2.852,2.313-5.163,5.164-5.163s5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163S2851.166,1589.846,2851.166,1586.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2697.135,1390.059c0,0,15.858-3.688,19.915,0c4.057,3.688,5.348,9.035,5.348,9.035h-25.263 V1390.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2526.219,1330.258c0,0-22.701,18.495-27.127,45.786c-4.425,27.291,49.803,22.865,49.803,22.865 L2526.219,1330.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2596.589,1568.16c0,0,1.019,15.868,4.089,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.797-5.639c-5.661-0.974-15.141-4.93-18.585-12.401 C2607.604,1558.191,2596.589,1568.16,2596.589,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2630.518,1568.16c0,0,1.019,15.868,4.09,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.798-5.639s-15.141-4.93-18.585-12.401C2641.533,1558.191,2630.518,1568.16,2630.518,1568.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2522.961,1437.633c-0.877,0.737-10.814,28.396-10.229,46.837h75.993c0,0,24.506,4.379,25.09,9.675 c0.585,5.296,5.6,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.677-6.393-52.853-25.398-68.452-27.291 S2522.961,1437.633,2522.961,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2506.468,1437.633c-0.877,0.737-11.063,30.609,1.845,46.837h47.501c0,0,24.506,4.379,25.091,9.675 c0.584,5.296,5.599,33.843,15.536,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.676-6.393-52.853-25.398-68.452-27.291 C2520.281,1437.953,2506.468,1437.633,2506.468,1437.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2553.849,1325.491l11.396,7.472l16.471-3.069c-0.228-1.33-1.315-6.841-2.306-11.832 c-0.06-0.294-0.119-0.589-0.175-0.876c-0.849-4.248-1.581-7.896-1.581-7.896l-15.384-6.787l-5.735-2.53 c0.015,0.089,0.444,4.714,0.504,5.388C2558.115,1317.348,2553.849,1325.491,2553.849,1325.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2583.453,1308.354c0,0-24.78,7.73-29.356-7.775c-4.577-15.506-10.857-24.951,4.771-30.542 c15.629-5.592,20.463-0.586,23.249,4.218C2584.902,1279.059,2589.781,1305.943,2583.453,1308.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5453C"
    },
    d: "M2581.143,1272.761c0,0-1.58,18.044-5.312,17.26c-3.731-0.783-7.116-1.363-6.569,4.075 c0.547,5.439,5.721,11.721-5.779,12.683s-28.032-28.696-24.873-34.312C2547.725,1256.265,2594.318,1252.995,2581.143,1272.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2577.498,1321.721c-0.32-0.135-18.447-8.267-20.567-7.566s-4.763,7.175-4.763,7.175l31.92,7.217 C2584.088,1328.546,2581.575,1323.438,2577.498,1321.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2605.687,1345.751c0,0-10.067-14.599-21.599-17.205c-11.531-2.607-31.92-7.217-31.92-7.217 s-26.479,5.595-29.185,12.211s-27.3,117.384-19.957,127.818s76.683,9.52,86.543,2.673c9.861-6.847,11.479-52.059,13.219-78.402 C2604.527,1359.286,2605.687,1345.751,2605.687,1345.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2563.571,1470.777h-57.483c-9.979,0-18.145-8.164-18.145-18.145v-85.078 c0-9.979,8.165-18.145,18.145-18.145h57.483c9.979,0,18.145,8.165,18.145,18.145v85.078 C2581.716,1462.613,2573.551,1470.777,2563.571,1470.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2615.03,1512.498h-116.013c-4.066,0-7.394-3.327-7.394-7.394v-13.242 c0-4.065,3.327-7.393,7.394-7.393h116.013c4.066,0,7.394,3.327,7.394,7.393v13.242 C2622.424,1509.171,2619.097,1512.498,2615.03,1512.498z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2552.804,
    y: 1512.498,
    style: {
      fill: "#2B478B"
    },
    width: 8.44,
    height: 69.333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2584.088,1328.546c0,0,17.99,1.952,28.136,18.732c6.274,10.377,24.244,34.113,36.046,34.851 s48.865,7.93,48.865,7.93v9.116l-56.506,1.55c-0.691,0.02-1.377-0.034-2.057-0.162c-6.039-1.14-36.729-7.252-41.381-14.562 C2592.028,1377.888,2584.088,1328.546,2584.088,1328.546z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2527.858,
    y: 1577.406,
    style: {
      fill: "#2B478B"
    },
    width: 58.27,
    height: 4.425
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2526.752,1586.994c0-2.852,2.312-5.163,5.163-5.163s5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163S2526.752,1589.846,2526.752,1586.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2574.572,1586.994c0-2.852,2.312-5.163,5.163-5.163s5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163S2574.572,1589.846,2574.572,1586.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1634.262,1388.184c0,0,15.857-3.688,19.914,0c4.057,3.688,5.348,9.035,5.348,9.035h-25.262 V1388.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1463.345,1328.383c0,0-22.701,18.495-27.126,45.786c-4.426,27.291,49.803,22.865,49.803,22.865 L1463.345,1328.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1533.715,1566.285c0,0,1.019,15.868,4.089,16.089c0.409,0.029,15.573-0.003,15.573-0.003 l19.359-0.154c0,0-0.137-4.665-5.798-5.639s-15.141-4.93-18.585-12.401C1544.73,1556.316,1533.715,1566.285,1533.715,1566.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1567.644,1566.285c0,0,1.019,15.868,4.089,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.797-5.639s-15.141-4.93-18.585-12.401C1578.659,1556.316,1567.644,1566.285,1567.644,1566.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1460.087,1435.758c-0.877,0.737-10.814,28.396-10.23,46.837h75.993c0,0,24.506,4.379,25.091,9.675 c0.584,5.296,5.599,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.677-6.393-52.853-25.398-68.452-27.291 C1490.318,1436.078,1460.087,1435.758,1460.087,1435.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1443.594,1435.758c-0.877,0.737-11.064,30.609,1.844,46.837h47.501c0,0,24.506,4.379,25.09,9.675 s5.599,33.843,15.537,74.41h15.783c0,0-3.215-95.026-7.892-101.418c-4.676-6.393-52.853-25.398-68.452-27.291 C1457.407,1436.078,1443.594,1435.758,1443.594,1435.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1490.975,1323.616l11.397,7.472l16.471-3.069c-0.228-1.33-1.315-6.841-2.305-11.832 c-0.06-0.294-0.12-0.589-0.176-0.876c-0.848-4.248-1.581-7.896-1.581-7.896l-15.384-6.787l-5.736-2.53 c0.015,0.089,0.445,4.713,0.504,5.388C1495.242,1315.473,1490.975,1323.616,1490.975,1323.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1520.579,1306.479c0,0-24.78,7.73-29.356-7.775c-4.576-15.506-10.856-24.951,4.771-30.542 c15.628-5.592,20.462-0.586,23.249,4.218C1522.029,1277.184,1526.907,1304.068,1520.579,1306.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5453C"
    },
    d: "M1518.27,1270.886c0,0-1.581,18.044-5.312,17.26c-3.731-0.783-7.116-1.363-6.569,4.075 c0.546,5.439,5.721,11.721-5.779,12.683s-28.032-28.696-24.873-34.312C1484.851,1254.39,1531.444,1251.12,1518.27,1270.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1514.624,1319.846c-0.32-0.135-18.447-8.267-20.567-7.566c-2.12,0.7-4.762,7.175-4.762,7.175 l31.919,7.217C1521.214,1326.671,1518.702,1321.563,1514.624,1319.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1542.813,1343.876c0,0-10.067-14.599-21.599-17.205c-11.531-2.607-31.919-7.217-31.919-7.217 s-26.479,5.595-29.185,12.211s-27.3,117.384-19.958,127.818s76.683,9.52,86.544,2.673c9.86-6.847,11.479-52.059,13.218-78.402 C1541.653,1357.411,1542.813,1343.876,1542.813,1343.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1500.698,1468.902h-57.483c-9.979,0-18.145-8.164-18.145-18.145v-85.078 c0-9.979,8.165-18.145,18.145-18.145h57.483c9.979,0,18.145,8.165,18.145,18.145v85.078 C1518.842,1460.738,1510.677,1468.902,1500.698,1468.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1552.156,1510.623h-116.013c-4.066,0-7.393-3.327-7.393-7.394v-13.242 c0-4.065,3.327-7.393,7.393-7.393h116.013c4.066,0,7.394,3.327,7.394,7.393v13.242 C1559.55,1507.296,1556.223,1510.623,1552.156,1510.623z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1489.93,
    y: 1510.623,
    style: {
      fill: "#2B478B"
    },
    width: 8.44,
    height: 69.333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1521.214,1326.671c0,0,17.991,1.952,28.136,18.732c6.274,10.377,24.245,34.113,36.046,34.851 s48.866,7.93,48.866,7.93v9.116l-56.506,1.55c-0.692,0.02-1.376-0.034-2.057-0.162c-6.039-1.14-36.729-7.252-41.381-14.562 C1529.155,1376.013,1521.214,1326.671,1521.214,1326.671z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1464.984,
    y: 1575.531,
    style: {
      fill: "#2B478B"
    },
    width: 58.269,
    height: 4.425
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1463.878,1585.119c0-2.852,2.312-5.163,5.163-5.163s5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163S1463.878,1587.971,1463.878,1585.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1511.698,1585.119c0-2.852,2.312-5.163,5.164-5.163c2.851,0,5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163C1514.01,1590.282,1511.698,1587.971,1511.698,1585.119z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1869.877,1388.184c0,0,15.857-3.688,19.914,0c4.058,3.688,5.348,9.035,5.348,9.035h-25.262 V1388.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1698.961,1328.383c0,0-22.701,18.495-27.127,45.786s49.803,22.865,49.803,22.865 L1698.961,1328.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1769.33,1566.285c0,0,1.019,15.868,4.09,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.798-5.639c-5.661-0.974-15.141-4.93-18.585-12.401 C1780.346,1556.316,1769.33,1566.285,1769.33,1566.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1803.259,1566.285c0,0,1.019,15.868,4.09,16.089c0.408,0.029,15.573-0.003,15.573-0.003 l19.358-0.154c0,0-0.137-4.665-5.798-5.639c-5.66-0.974-15.141-4.93-18.585-12.401 C1814.274,1556.316,1803.259,1566.285,1803.259,1566.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1695.702,1435.758c-0.876,0.737-10.814,28.396-10.229,46.837h75.993 c0,0,24.506,4.379,25.091,9.675c0.584,5.296,5.599,33.843,15.536,74.41h15.784c0,0-3.216-95.026-7.893-101.418 c-4.676-6.393-52.853-25.398-68.451-27.291C1725.934,1436.078,1695.702,1435.758,1695.702,1435.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1679.21,1435.758c-0.877,0.737-11.064,30.609,1.844,46.837h47.501c0,0,24.506,4.379,25.091,9.675 c0.585,5.296,5.6,33.843,15.537,74.41h15.783c0,0-3.216-95.026-7.892-101.418c-4.677-6.393-52.854-25.398-68.452-27.291 C1693.022,1436.078,1679.21,1435.758,1679.21,1435.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1726.59,1323.616l11.396,7.472l16.472-3.069c-0.229-1.33-1.315-6.841-2.306-11.832 c-0.06-0.294-0.12-0.589-0.176-0.876c-0.849-4.248-1.58-7.896-1.58-7.896l-15.384-6.787l-5.736-2.53 c0.016,0.089,0.444,4.713,0.505,5.388C1730.857,1315.473,1726.59,1323.616,1726.59,1323.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1756.194,1306.479c0,0-24.78,7.73-29.356-7.775s-10.856-24.951,4.771-30.542 c15.628-5.592,20.462-0.586,23.248,4.218C1757.645,1277.184,1762.522,1304.068,1756.194,1306.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1753.885,1270.886c0,0-1.58,18.044-5.313,17.26c-3.73-0.783-7.115-1.363-6.569,4.075 c0.547,5.439,5.722,11.721-5.778,12.683c-11.501,0.962-28.033-28.696-24.874-34.312 C1720.467,1254.39,1767.06,1251.12,1753.885,1270.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1750.239,1319.846c-0.319-0.135-18.447-8.267-20.567-7.566s-4.763,7.175-4.763,7.175l31.92,7.217 C1756.829,1326.671,1754.316,1321.563,1750.239,1319.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1778.428,1343.876c0,0-10.067-14.599-21.599-17.205c-11.531-2.607-31.92-7.217-31.92-7.217 s-26.479,5.595-29.184,12.211c-2.706,6.616-27.301,117.384-19.958,127.818s76.684,9.52,86.544,2.673s11.479-52.059,13.218-78.402 C1777.269,1357.411,1778.428,1343.876,1778.428,1343.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1736.313,1468.902h-57.484c-9.979,0-18.145-8.164-18.145-18.145v-85.078 c0-9.979,8.165-18.145,18.145-18.145h57.484c9.979,0,18.145,8.165,18.145,18.145v85.078 C1754.458,1460.738,1746.293,1468.902,1736.313,1468.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1787.771,1510.623h-116.013c-4.066,0-7.394-3.327-7.394-7.394v-13.242 c0-4.065,3.327-7.393,7.394-7.393h116.013c4.066,0,7.394,3.327,7.394,7.393v13.242 C1795.165,1507.296,1791.838,1510.623,1787.771,1510.623z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1725.545,
    y: 1510.623,
    style: {
      fill: "#2B478B"
    },
    width: 8.441,
    height: 69.333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1756.829,1326.671c0,0,17.99,1.952,28.137,18.732c6.274,10.377,24.244,34.113,36.045,34.851 c11.802,0.737,48.866,7.93,48.866,7.93v9.116l-56.506,1.55c-0.692,0.02-1.377-0.034-2.058-0.162 c-6.039-1.14-36.729-7.252-41.38-14.562C1764.77,1376.013,1756.829,1326.671,1756.829,1326.671z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700.6,
    y: 1575.531,
    style: {
      fill: "#2B478B"
    },
    width: 58.269,
    height: 4.425
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1699.493,1585.119c0-2.852,2.312-5.163,5.163-5.163s5.163,2.312,5.163,5.163 s-2.312,5.163-5.163,5.163S1699.493,1587.971,1699.493,1585.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1747.313,1585.119c0-2.852,2.312-5.163,5.163-5.163s5.163,2.312,5.163,5.163 s-2.311,5.163-5.163,5.163S1747.313,1587.971,1747.313,1585.119z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffshoreDev);
export default __webpack_public_path__ + "static/media/offshoreDev.0efffa82e041279067a7442d728fb236.svg";
export { ForwardRef as ReactComponent };